const t = document.documentElement,
    e = t.getAttribute("dir"),
    i = "rtl" == e,
    s = "shopify:block:select",
    n = "shopify:block:deselect",
    a = "shopify:section:select",
    r = "shopify:section:deselect",
    o = "shopify:section:load",
    h = "shopify:section:unload",
    l = "shopify:section:reorder";
var d = (t, e = document) => e.querySelector(t),
    c = (t) => document.getElementById(t),
    u = (t, e = document) => [...e.querySelectorAll(t)],
    p = (t, e, i, s = !0) => {
        if (s ? !e.has(t) : e.has(t)) throw TypeError("Cannot " + i);
    },
    m = (t, e, i) => (p(t, e, "access private method"), i),
    b = (t, e, i) => {
        p(t, e, "Cannot add the same private member more than once", !1), e instanceof WeakSet ? e.add(t) : e.set(t, i);
    },
    g = (t, e, i, s) => (p(t, e, "write to private field"), s ? s.call(t, i) : e.set(t, i), i),
    v = (t, e, i) => (p(t, e, "read from private field"), i ? i.call(t) : e.get(t)),
    f = (t, e, i, s = !1) => {
        (!s && t.has(e)) || (t instanceof WeakSet ? t.add(e) : t.set(e, i));
    },
    w = (t, e, i) => {
        if (!t.has(e)) {
            if (!i) return !1;
            f(t, e, i, !0);
        }
        return t.get(e);
    },
    y = (t, e, i) => {
        if (!t.has(e)) throw TypeError(t + "no exist");
        return i;
    },
    E = (t, e) => {
        t.has(e) && t.delete(e);
    },
    C = { nvt: 1 };
function k(t, e = "") {
    "string" == typeof t && (t = t.replace(".", ""));
    const i = /\{\{\s*(\w+)\s*\}\}/,
        s = e || window.themeHDN.settings.moneyFormat;
    function n(t, e) {
        return null == t || t != t ? e : t;
    }
    function a(t, e, i, s) {
        if (((e = n(e, 2)), (i = n(i, ",")), (s = n(s, ".")), isNaN(t) || null == t)) return 0;
        let a = (t = (t / 100).toFixed(e)).split(".");
        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? s + a[1] : "");
    }
    let r = "";
    switch (s.match(i)[1]) {
        case "amount":
            r = a(t, 2);
            break;
        case "amount_no_decimals":
            r = a(t, 0);
            break;
        case "amount_with_space_separator":
            r = a(t, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            r = a(t, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            r = a(t, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            r = a(t, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            r = a(t, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            r = a(t, 0, "'");
    }
    return s.indexOf("with_comma_separator"), s.replace(i, r);
}
function x(t) {
    let e,
        i = null;
    const s = (...s) => {
        var n;
        (e = s),
            null === i &&
                (i = requestAnimationFrame(
                    ((n = this),
                    () => {
                        (i = null), t.apply(n, e);
                    })
                ));
    };
    return (
        (s.cancel = () => {
            cancelAnimationFrame(i), (i = null);
        }),
        s
    );
}
function A(t, e) {
    let i;
    return (...s) => {
        clearTimeout(i), (i = setTimeout(() => t.apply(this, s), e));
    };
}
function S(t, e) {
    return new Promise((i) => {
        const s = (n) => {
            n.target === t && (t.removeEventListener(e, s), i(n));
        };
        t.addEventListener(e, s);
    });
}
function L(t = "hdt") {
    do {
        t += crypto.randomUUID ? crypto.randomUUID() : ~~(1e6 * Math.random());
    } while (c(t));
    return t;
}
function _(t, e) {
    switch (t) {
        case "phone":
            return window.matchMedia("screen and (max-width: 767px)").matches;
        case "tablet":
            return window.matchMedia("screen and (min-width: 768px) and (max-width: 1149px)").matches;
        case "supports-hover":
            return window.matchMedia("screen and (hover: hover) and (pointer: fine)").matches;
        case "motion":
            return window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
        case "motion-reduce":
            return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        default:
            return (window.matchMedia(t).onchange = e);
    }
}
function M(t) {
    const e = new Image(t.width, t.height),
        i = t.attrs || {};
    for (const t in i) e.setAttribute(t, i[t]);
    return (
        (e.alt = t.alt || ""),
        (e.src = t.src),
        (e.srcset = T(t.src, JSON.parse(t.attrs["data-widths"]))),
        t.onload &&
            e.addEventListener(
                "load",
                function () {
                    const t = e.parentElement;
                    t && (t.removeAttribute("loading"), t.setAttribute("loaded", ""));
                },
                { once: !0 }
            ),
        e
    );
}
function T(t, e) {
    let i = new URL(t.startsWith("//") ? `https:${t}` : t),
        s = parseInt(i.searchParams.get("width") || e[e.length - 1]);
    return e
        .filter((t) => t <= s)
        .map((t) => (i.searchParams.set("width", t.toString()), `${i.href} ${t}w`))
        .join(", ");
}
function W(t) {
    return "function" == typeof t;
}
const P = new Map();
async function I(t, e = "", i) {
    const s = t + e;
    if (P.has(s)) return Promise.resolve(new Response(new Blob([P.get(s)])));
    const n = await fetch(t, i);
    if (200 === n.status) {
        const t = n.headers.get("Content-Type");
        ((t && t.match(/text\//i)) || t.match(/application\/json/i)) &&
            n
                .clone()
                .text()
                .then((t) => {
                    P.set(s, t);
                });
    }
    return n;
}
const $ = {};
class O {
    static load(t) {
        if (t)
            return (
                $[t] ||
                    ($[t] = new Promise(async (e, i) => {
                        const s = await fetch(`${Shopify.routes.root}products/${t}.js`);
                        if (s.ok) {
                            e(await s.json());
                        } else i(`${t} not loaded json`);
                    })),
                $[t]
            );
    }
}
function H(t) {
    if (!t.observes) return;
    document.addEventListener("visibilitychange", () => {
        "visible" === document.visibilityState ? W(t.play) && t.observes.isInview && t.play() : W(t.pause) && t.pause();
    });
}
function N(t = document) {
    const e = u(".hdt-rte table:not(.hdt-wrapper-added)", t);
    0 != e.length &&
        e.forEach((t) => {
            t.classList.add("hdt-wrapper-added"),
                (t.outerHTML = `<div class="hdt-scrollable-wrapper">${t.outerHTML}</div>`);
        });
}
function R(t = document) {
    const { hostname: e } = window.location,
        i = u("a[href]:not([aria-describedby])", t);
    0 != i.length &&
        i.forEach((t) => {
            const i = t.hostname !== e;
            if ("_blank" === t.getAttribute("target")) {
                t.setAttribute("aria-describedby", i ? "a11y-new-window-external-message" : "a11y-new-window-message");
                const e = t.getAttribute("rel");
                (e && -1 !== e.indexOf("noopener")) || t.setAttribute("rel", (e ? e + " " : "") + "noopener");
            } else i && t.setAttribute("aria-describedby", "a11y-external-message");
        });
}
function q(t = document) {
    const { root: e } = Shopify.routes,
        { hostname: i } = window.location;
    "/" != e &&
        (u('a[href="/"]', t).forEach((t) => t.setAttribute("href", e)),
        u(`a[href*="${i}/"]:not([href*="${i + e}"],[href*="@"],[href*="preview_theme_id="])`, t).forEach((t) =>
            t.setAttribute("href", t.getAttribute("href").replace(`${i}/`, i + e))
        ));
}
var D, F, B, V, z, Y, j, X, U, J, Z, Q, G, K, tt, et, it, st;
class nt {
    constructor(t, e, i) {
        const s = { key: i || t };
        (this.keyid_ = s),
            f(st, s, s),
            f(it, s, t),
            f(F, s, e),
            f(B, s, V.bind(this)),
            f(z, s),
            f(Z, s),
            f(j, s),
            f(U, s),
            f(K, s, void 0),
            f(tt, s),
            f(et, s),
            (w(it, s).isActive = !1),
            w(it, s)?.addEventListener("mouseenter", y(Z, s, Q).bind(this, s)),
            w(it, s)?.addEventListener("mouseleave", y(Z, s, Q).bind(this, s));
    }
    get config() {
        return w(D, w(st, this.keyid_), Object.assign(w(G, C), w(F, w(st, this.keyid_))));
    }
}
(st = new WeakMap()),
    (D = new WeakMap()),
    (F = new WeakMap()),
    (B = new WeakMap()),
    (z = new WeakSet()),
    (j = new WeakSet()),
    (U = new WeakSet()),
    (Z = new WeakSet()),
    (G = new Map()),
    f(G, C, { exitDelay: 0, interval: 100, sensitivity: 6 }),
    (K = new WeakMap()),
    (it = new WeakMap()),
    (tt = new WeakSet()),
    (et = new WeakSet()),
    (V = function (t) {
        (this.cX = t.pageX), (this.cY = t.pageY);
    }),
    (Y = function (t, e) {
        if (
            Math.sqrt(
                (this.prevX - this.cX) * (this.prevX - this.cX) + (this.prevY - this.cY) * (this.prevY - this.cY)
            ) < this.config.sensitivity
        )
            return (
                t?.removeEventListener("mousemove", w(B, e)),
                E(K, e),
                t.isActive && (this.config.onExit(t), (t.isActive = !1)),
                (t.isActive = !0),
                (this.ev.pageX = this.cX),
                (this.ev.pageY = this.cY),
                delete this.prevX,
                delete this.prevY,
                this.config.onEnter(t)
            );
        (this.prevX = this.cX),
            (this.prevY = this.cY),
            f(
                K,
                e,
                setTimeout(() => {
                    y(z, e, Y).call(this, t, e);
                }, this.config.interval),
                !0
            );
    }),
    (X = function (t, e) {
        t.isActive ||
            ((this.prevX = this.ev.pageX),
            (this.prevY = this.ev.pageY),
            t?.removeEventListener("mousemove", w(B, e)),
            t?.addEventListener("mousemove", w(B, e, V.bind(this))),
            f(
                K,
                e,
                setTimeout(() => {
                    y(z, e, Y).call(this, t, e);
                }, this.config.interval),
                !0
            ));
    }),
    (J = function (t, e) {
        t.isActive &&
            (t?.removeEventListener("mousemove", w(B, e)),
            f(
                K,
                e,
                setTimeout(() => {
                    this.config.onExit(t), (t.isActive = !1);
                }, this.config.exitDelay),
                !0
            ));
    }),
    (Q = function (t, e) {
        (this.ev = Object.assign({}, e)),
            f(K, t, clearTimeout(w(K, t)), !0),
            y("mouseenter" === e.type ? j : U, t, "mouseenter" === e.type ? X : J).call(this, w(it, t), t);
    });
import {
    Carousel as at,
    ClassNames as rt,
    AutoHeight as ot,
    navUICenter as ht,
    Autoplay as lt,
    navHandlers as dt,
    dotHandlers as ct,
    FocusTrap as ut,
    Delegate as pt,
    animate as mt,
    scroll as bt,
    timeline as gt,
    inView as vt,
    stagger as ft,
} from "vendor";
at.globalOptions = { direction: e };
var wt,
    yt,
    Et,
    Ct,
    kt,
    xt,
    At,
    St,
    Lt,
    _t,
    Mt,
    Tt,
    Wt,
    Pt,
    It,
    $t,
    Ot = "is--enabled",
    Ht = {
        loop: !1,
        align: "start",
        containScroll: "trimSnaps",
        skipSnaps: !0,
        watchSlides: !1,
        watchDrag: "smart",
        slidesToScroll: "auto",
        inViewThreshold: 0.5,
        classNames: !0,
        autoHeight: !1,
        autoPlay: 0,
        pauseOnHover: !1,
        navUI: !1,
        navUICenter: !1,
        dotUI: !1,
        controlUI: !1,
        a11ySlide: !0,
        a11yKeyBoard: !0,
        a11yControls: !0,
        inView: "is-in-view",
    },
    Nt = "hdt-slider__slide";
class Rt extends HTMLElement {
    constructor() {
        super(),
            f(yt, this),
            f(wt, this, new pt(document.body)),
            f(Lt, this),
            f(Mt, this),
            f(Wt, this),
            f(Ct, this),
            f(St, this, Object.assign({}, Ht, JSON.parse(this.getAttribute("config") || "{}"))),
            f(xt, this, u(`[hdt-slider-controls][aria-controls="${this.id}"] > button`)),
            "onlyTypeImage" == w(St, this).watchDrag
                ? (w(St, this).watchDrag = (t, e) => {
                      const i = e.target.closest("[data-media-type]");
                      return !i || "image" == i.getAttribute("data-media-type");
                  })
                : "smart" == w(St, this).watchDrag && (w(St, this).watchDrag = (t, e) => t.scrollSnapList().length > 1),
            "#65" == w(St, this).watchResize &&
                (w(St, this).watchResize = (t, e) => {
                    for (const i of e) {
                        if (t.containerNode() === i.target && i.contentRect.height != i.target.prevHeight)
                            return (i.target.prevHeight = i.contentRect.height), !0;
                        if (t.containerNode() === i.target) return !1;
                        window.requestAnimationFrame(() => {
                            t.reInit(), t.emit("resize");
                        });
                        break;
                    }
                    return !1;
                }),
            this.id || (this.id = L());
    }
    goToTarget(t, e) {
        this.goToIndex(w(At, this).slideNodes().indexOf(t), e || !_("motion"));
    }
    goToIndex(t, e) {
        let i,
            s = parseInt(t);
        const n = w(At, this).scrollSnapList().length;
        if (w(At, this).slideNodes().length !== n) {
            const { slideRegistry: t } = w(At, this).internalEngine();
            for (i = 0; i < t.length; i++)
                if (t[i].indexOf(s) > -1) {
                    s = i;
                    break;
                }
        }
        w(At, this).scrollTo(Math.min(s, n - 1), e || !_("motion"));
    }
    get isActive() {
        return w(At, this).internalEngine().options.active;
    }
    reInit() {
        w(At, this).reInit();
    }
    connectedCallback() {
        const t = [];
        if (
            (w(St, this).classNames && t.push(rt({ inView: "is-in-view" })),
            w(St, this).autoHeight && t.push(ot()),
            w(St, this).navUI && w(St, this).navUICenter && t.push(ht()),
            w(St, this).autoPlay)
        ) {
            const e = {
                delay: w(St, this).autoPlay,
                stopOnInteraction: !1,
                stopOnMouseEnter: w(St, this).pauseOnHover,
            };
            t.push(lt(e));
        }
        if (
            (f(At, this, at(d(".hdt-slider__viewport", this) || this, w(St, this), t)),
            w(At, this)
                .on("init", y(Lt, this, _t).bind(this))
                .on("resize", y(Lt, this, _t).bind(this))
                .on("reInit", y(Lt, this, _t).bind(this))
                .on("select", y(Wt, this, Pt).bind(this))
                .on("destroy", y(Mt, this, Tt).bind(this)),
            w(St, this).navUI)
        ) {
            const t = u(`button[name="next"][aria-controls="${this.id}"]`);
            u(`button[name="previous"][aria-controls="${this.id}"]`).forEach((e, i) => {
                if (e && t[i]) {
                    const s = dt(w(At, this), e, t[i]);
                    w(At, this).on("destroy", s);
                }
            });
        }
        w(St, this).dotUI &&
            u(`[hdt-slider-dots][aria-controls="${this.id}"]`).forEach((t) => {
                if (t) {
                    const e = ct(w(At, this), t);
                    w(At, this).on("destroy", e);
                }
            }),
            w(St, this).controlUI &&
                w(xt, this).length > 0 &&
                (w(wt, this).on(
                    "click",
                    `[hdt-slider-controls][aria-controls="${this.id}"] > button`,
                    y(Ct, this, kt).bind(this)
                ),
                w(At, this)
                    .on("init", y(yt, this, Et).bind(this))
                    .on("reInit", y(yt, this, Et).bind(this))
                    .on("select", y(yt, this, Et).bind(this))
                    .on("destroy", y(yt, this, Et).bind(this))),
            Shopify.designMode &&
                this.addEventListener(s, (t) => {
                    let e = t.target;
                    e.classList.contains(Nt) || (e = e.closest(`.${Nt}`)), this.goToTarget(e, t.detail.load);
                });
    }
    disconnectedCallback() {
        w(At, this) && w(At, this).destroy();
    }
}
(At = new WeakMap()),
    (St = new WeakMap()),
    (wt = new WeakMap()),
    (xt = new WeakMap()),
    (Lt = new WeakSet()),
    (_t = function (t, e) {
        const i = "resize" === e,
            s = i ? "remove" : "add",
            n = this.hasAttribute("isfade");
        this.classList[s](Ot),
            i &&
                n &&
                (clearTimeout(this.timeout),
                (this.timeout = setTimeout(() => {
                    t.reInit();
                }, 4))),
            !i && n && (t.internalEngine().translate.toggleActive(!1), t.internalEngine().translate.clear());
    }),
    (Mt = new WeakSet()),
    (Tt = function () {
        this.classList.remove(Ot), w(wt, this).off();
    }),
    (yt = new WeakSet()),
    (Et = function (t) {
        if (!this.isActive) return;
        const e = t.selectedScrollSnap();
        w(xt, this).forEach((t) => t.setAttribute("aria-current", t.value == e));
    }),
    (Ct = new WeakSet()),
    (kt = function (t, e) {
        "true" !== e.getAttribute("aria-current") && this.goToIndex(e.value);
    }),
    (Wt = new WeakSet()),
    (Pt = function (t, e) {
        this.dispatchEvent(new CustomEvent(`${e}:slide`, { bubbles: !1, detail: { sliderApi: t, eventName: e } }));
    });
(It = new WeakSet()),
    ($t = function (t) {
        const e = t.selectedScrollSnap(),
            i = t.previousScrollSnap(),
            s = u("[reval]", t.slideNodes()[e]),
            n = u("[reval]", t.slideNodes()[i]),
            a = s.filter((t) => this.isVisible(t)),
            r = n.filter((t) => this.isVisible(t));
        0 != a.length &&
            (mt(
                a,
                { opacity: [0, 1], transform: ["translateY(150px)", "translateY(0)"] },
                { duration: 0.25, easing: "ease", delay: ft(0.15, { start: 0.4, easing: [0, 0.87, 0.58, 1] }) }
            ),
            r.length > 0 &&
                e != i &&
                mt(
                    r,
                    { opacity: [1, 0], transform: ["translateY(0)", "translateY(25px)"] },
                    { duration: 0.15, easing: "ease", delay: ft(0.1, { start: 0.4, easing: [0, 0.87, 0.58, 1] }) }
                ));
    });
var qt,
    Dt,
    Ft,
    Bt,
    Vt = new WeakMap();
(qt = new WeakSet()),
    (Dt = function (t) {
        w(At, w(Vt, this)).selectedScrollSnap() != t.selectedScrollSnap() &&
            w(At, w(Vt, this)).scrollTo(t.selectedScrollSnap());
    }),
    (Ft = new WeakSet()),
    (Bt = function (t) {
        w(At, this).selectedScrollSnap() != t.selectedScrollSnap() && w(At, this).scrollTo(t.selectedScrollSnap());
    });
var zt,
    Yt,
    jt,
    Xt,
    Ut = new WeakMap();
(zt = new WeakSet()),
    (Yt = function (t, e) {
        const i = u(".hdt-slider__slide", this),
            s = (t) => {
                const i = e.slideNodes().indexOf(t);
                i > -1 && w(Ut, this).goToIndex(i);
            };
        return (
            i.forEach((t) => t.addEventListener("click", s.bind(this, t), !1)),
            () => {
                i.forEach((t) => t.removeEventListener("click", s.bind(this, t), !1));
            }
        );
    }),
    (jt = new WeakSet()),
    (Xt = function (t, e) {
        const i = () => {
            this.goToIndex(t.selectedScrollSnap()),
                d(".is-thumb-selected", this)?.classList.remove("is-thumb-selected"),
                e.slideNodes()[t.selectedScrollSnap()].classList.add("is-thumb-selected");
        };
        return (
            t.on("select", i),
            e.on("init", i),
            e.on("reInit", i),
            () => {
                e.slideNodes()[t.selectedScrollSnap()].classList.remove("is-thumb-selected");
            }
        );
    });
var Jt,
    Zt,
    Qt,
    Gt,
    Kt = new WeakMap();
class te extends HTMLElement {
    #t;
    constructor() {
        super(), f(Jt, this), f(Qt, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            f(Kt, this, c(this.getAttribute("slider"))),
            w(Kt, this) &&
                (w(At, w(Kt, this)).on("init", y(Jt, this, Zt).bind(this), { signal: this.#t.signal }),
                w(At, w(Kt, this)).on("reInit", y(Jt, this, Zt).bind(this), { signal: this.#t.signal }),
                w(At, w(Kt, this)).on("select", y(Qt, this, Gt).bind(this), { signal: this.#t.signal }));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get total() {
        return d("[update-total]", this);
    }
    get current() {
        return (this._current = this._current || d("[update-current]", this));
    }
}
(Jt = new WeakSet()),
    (Zt = function (t) {
        w(Kt, this).isActive && ((this.total.textContent = t.scrollSnapList().length), y(Qt, this, Gt).call(this, t));
    }),
    (Qt = new WeakSet()),
    (Gt = function (t) {
        this.current.textContent = t.selectedScrollSnap() + 1;
    }),
    customElements.define("hdt-slider", Rt),
    customElements.define(
        "hdt-slider-lazy",
        class extends Rt {
            constructor() {
                super();
            }
            connectedCallback() {}
            InitLazy() {
                super.connectedCallback();
            }
        }
    ),
    customElements.define(
        "hdt-slideshow",
        class extends Rt {
            constructor() {
                super(), f(It, this);
            }
            connectedCallback() {
                super.connectedCallback(),
                    w(At, this).on("init", y(It, this, $t).bind(this)),
                    w(At, this).on("reInit", y(It, this, $t).bind(this)),
                    w(At, this).on("select", y(It, this, $t).bind(this)),
                    w(At, this).on("destroy", y(It, this, $t).bind(this));
            }
            isVisible(t) {
                return t.offsetWidth > 0 || t.offsetHeight > 0;
            }
        }
    ),
    customElements.define(
        "hdt-slider-sync",
        class extends Rt {
            constructor() {
                super(), f(Vt, this, c(this.getAttribute("aria-controls"))), f(qt, this), f(Ft, this);
            }
            connectedCallback() {
                super.connectedCallback(),
                    w(At, w(Vt, this)) &&
                        (w(At, w(Vt, this)).on("select", y(Ft, this, Bt).bind(this)),
                        w(At, this).on("select", y(qt, this, Dt).bind(this)),
                        w(At, w(Vt, this)).on("destroy", () => {
                            w(At, this).off("select", y(qt, this, Dt).bind(this));
                        }),
                        w(At, this).on("destroy", () => {
                            w(At, w(Vt, this)).off("select", y(Ft, this, Bt).bind(this));
                        }));
            }
        }
    ),
    customElements.define(
        "hdt-slider-thumb",
        class extends Rt {
            connectedCallback() {
                if (
                    (f(Ut, this, c(this.getAttribute("aria-controls"))),
                    this.hasAttribute("stagger") &&
                        mt(
                            u("[reval]", this),
                            {
                                opacity: [0, 1],
                                transform: ["scale(.5) rotate(90deg) skew(15deg)", "scale(1) rotate(0deg) skew(0deg)"],
                            },
                            { duration: 0.2, delay: ft(0.3, { easing: "ease-out" }) }
                        ).finished.then(() => {
                            this.classList.add("stagger-finished");
                        }),
                    !w(Ut, this))
                )
                    return;
                super.connectedCallback();
                const t = w(At, w(Ut, this)),
                    e = w(At, this);
                _("phone") ||
                    _("tablet") ||
                    e
                        .containerNode()
                        .style.setProperty(
                            "max-height",
                            `${t.slideNodes()[t.selectedScrollSnap()].clientHeight + 10}px`
                        ),
                    f(zt, this),
                    f(jt, this);
                const i = y(zt, this, Yt).call(this, t, e),
                    s = y(jt, this, Xt).call(this, t, e);
                t.on("destroy", i).on("destroy", s), e.on("destroy", i).on("destroy", s);
            }
        }
    ),
    customElements.define("hdt-slider-counter", te);
class ee extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = d('[id^="Scroller-"]', this) || this),
            (this.sliderItems = u('[id^="Scroll-"]', this)),
            (this.enableSliderLooping = !1),
            (this.currentPageElement = d(".hdt-scrollsnap-counter--current", this)),
            (this.pageTotalElement = d(".hdt-scrollsnap-counter--total", this)),
            (this.prevButton = d('button[name="previous"]', this)),
            (this.nextButton = d('button[name="next"]', this)),
            (this.dotButtons = u(".hdt-scrollsnap-dot__link", this)),
            (this.sliderFirstItemNode = this.sliderItems[0]),
            !this.slider)
        )
            return;
        this.initPages();
        new ResizeObserver((t) => this.initPages()).observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.nextButton &&
                (this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
                this.nextButton.addEventListener("click", this.onButtonClick.bind(this))),
            this.dotButtons.length &&
                this.dotButtons.forEach((t) => t.addEventListener("click", this.linkToSlide.bind(this)));
    }
    get isScrollable() {
        return this.slider.scrollWidth !== this.slider.clientWidth;
    }
    initPages() {
        (this.sliderItemsToShow = Array.from(this.sliderItems).filter((t) => t.clientWidth > 0)),
            this.sliderItemsToShow.length < 2 ||
                ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
                (this.slidesPerPage = Math.floor(
                    (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
                )),
                (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
                this.update(),
                this.classList.toggle("is-scrollable", this.isScrollable));
    }
    resetPages() {
        (this.sliderItems = u('[id^="Scroll-"]', this)), this.initPages();
    }
    update() {
        if (!this.slider) return;
        const t = this.currentPage;
        (this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
            this.currentPageElement &&
                this.pageTotalElement &&
                ((this.currentPageElement.textContent = this.currentPage),
                (this.pageTotalElement.textContent = this.totalPages)),
            this.currentPage != t &&
                this.dispatchEvent(
                    new CustomEvent("slideChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.sliderItemsToShow[this.currentPage - 1],
                        },
                    })
                ),
            this.dotButtons.length &&
                (this.dotButtons.forEach((t) => {
                    t.classList.remove("hdt-scrollsnap-dot__link--active"), t.removeAttribute("aria-current");
                }),
                this.dotButtons[this.currentPage - 1]?.classList.add("hdt-scrollsnap-dot__link--active"),
                this.dotButtons[this.currentPage - 1]?.setAttribute("aria-current", !0)),
            !this.enableSliderLooping &&
                this.nextButton &&
                (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft
                    ? this.prevButton.setAttribute("disabled", "disabled")
                    : this.prevButton.removeAttribute("disabled"),
                this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
                    ? this.nextButton.setAttribute("disabled", "disabled")
                    : this.nextButton.removeAttribute("disabled"));
    }
    isSlideVisible(t, e = 0) {
        const i = this.slider.clientWidth + this.slider.scrollLeft - e;
        return t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(t) {
        t.preventDefault();
        const e = t.currentTarget.dataset.step || 1;
        (this.slideScrollPosition =
            "next" === t.currentTarget.name
                ? this.slider.scrollLeft + e * this.sliderItemOffset
                : this.slider.scrollLeft - e * this.sliderItemOffset),
            this.setSlidePosition(this.slideScrollPosition);
    }
    linkToSlide(t) {
        t.preventDefault();
        const e =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth * (this.dotButtons.indexOf(t.currentTarget) + 1 - this.currentPage);
        this.setSlidePosition(e);
    }
    setSlidePosition(t) {
        this.slider.scrollTo({ left: t, behavior: _("motion") ? "smooth" : "auto" });
    }
}
customElements.define("hdt-scrollsnap", ee);
class ie extends HTMLElement {
    connectedCallback() {
        this.scrolledElement &&
            (this.scrolledElement.addEventListener("scroll", x(this._updateScrollProgress.bind(this))),
            window.ResizeObserver &&
                new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement));
    }
    get scrolledElement() {
        return (this._scrolledElement = this._scrolledElement || c(this.getAttribute("observes")));
    }
    _updateScrollProgress() {
        const t =
            ((i ? Math.abs(this.scrolledElement.scrollLeft) : this.scrolledElement.scrollLeft) +
                this.scrolledElement.clientWidth) /
            this.scrolledElement.scrollWidth;
        this.style.setProperty("--scrollbar-progress", Math.max(0, Math.min(t, 1)).toFixed(6));
    }
}
customElements.define("hdt-scrollbar", ie);
var se,
    ne,
    ae,
    re,
    oe,
    he,
    le,
    de,
    ce,
    ue,
    pe,
    me,
    be,
    ge,
    ve,
    fe,
    we,
    ye,
    Ee,
    Ce,
    ke,
    xe,
    Ae,
    Se = new WeakMap(),
    Le = new WeakMap(),
    _e = 0;
class Me extends HTMLElement {
    constructor() {
        super(),
            f(Se, this, new pt(document.body)),
            f(Le, this, void 0),
            b(this, se, void 0),
            b(this, ne, void 0),
            b(this, oe),
            b(this, ae),
            b(this, fe, void 0),
            b(this, ue),
            b(this, me),
            b(this, ge),
            b(this, ce, !1),
            b(this, le),
            this.shadowDomTemplate &&
                (this.attachShadow({ mode: "open" }).appendChild(c(this.shadowDomTemplate).content.cloneNode(!0)),
                this.shadowRoot.addEventListener("slotchange", (t) => m(this, ae, re).call(this, t.target))),
            this.addEventListener("dialog:forceClose", (t) => {
                this.closeDialog(), t.stopPropagation();
            });
    }
    static get observedAttributes() {
        return ["id", "open"];
    }
    updateBtbsOpen(t) {
        this.id &&
            t &&
            (t.removeEventListener("click", y(oe, this, he).bind(this)),
            t.addEventListener("click", y(oe, this, he).bind(this)));
    }
    connectedCallback() {
        "smart" == this.config.appendToBody && (this.config.appendToBody = _("phone")),
            "smart" == this.config.noScroll && (this.config.noScroll = _("phone")),
            this.id && this.delegate.off().on("click", this.stringControls, y(oe, this, he).bind(this)),
            g(this, Le, new AbortController()),
            this.setAttribute("role", "dialog"),
            this.shadowDomTemplate &&
                (this.selectorPartName("overlay")?.addEventListener("click", this.closeDialog.bind(this), {
                    signal: this.abortController.signal,
                }),
                u("slot", this.shadowRoot).forEach((t) => m(this, ae, re).call(this, t))),
            Shopify.designMode &&
                !this.hasAttribute("un-detect") &&
                (this.addEventListener(s, (t) => this.openDialog(t.detail.load), {
                    signal: this.abortController.signal,
                }),
                this.addEventListener(n, () => this.closeDialog(!1), { signal: this.abortController.signal }),
                (this._shopifySection = this._shopifySection || this.closest(".shopify-section")),
                this._shopifySection &&
                    (this.hasAttribute("detect-adm-se-evt") &&
                        (this._shopifySection.addEventListener(a, (t) => this.openDialog(!t.detail.load), {
                            signal: this.abortController.signal,
                        }),
                        this._shopifySection.addEventListener(r, this.closeDialog.bind(this), {
                            signal: this.abortController.signal,
                        })),
                    this._shopifySection.addEventListener(h, () => this.remove(), {
                        signal: this.abortController.signal,
                    })));
    }
    disconnectedCallback() {
        this.abortController.abort(),
            this.delegate.off(),
            this.focusTrap?.deactivate({ onDeactivate: () => {} }),
            v(this, ce) && (g(this, ce, !1), m(this, le, de).call(this));
    }
    get delegate() {
        return w(Se, this);
    }
    get abortController() {
        return w(Le, this);
    }
    get open() {
        return this.hasAttribute("open");
    }
    get defaultTemplate() {
        return null;
    }
    get shadowDomTemplate() {
        return this.getAttribute("template") || this.defaultTemplate;
    }
    get defaultConfig() {
        return { catchFocus: !0, preventScrollFocus: !0, allowOutsideClick: !0, noScroll: !0, appendToBody: !1 };
    }
    get userConfig() {
        return Object.assign(JSON.parse(this.getAttribute("config") || "{}"));
    }
    get config() {
        return g(this, ne, v(this, ne) || Object.assign(this.defaultConfig, this.userConfig));
    }
    attributeChangedCallback(t, e, i) {
        if ("open" === t) {
            if (
                (g(this, ce, this.open),
                this.allButton.forEach((t) => t.setAttribute("aria-expanded", null === i ? "false" : "true")),
                null !== e || ("" !== i && "immediate" !== i))
            ) {
                if (null !== e && null === i) {
                    this.dispatchEvent(new CustomEvent("dialog:beforeClose")), this.removeAttribute("opened");
                    const t = this.animateClose();
                    "immediate" === this.getAttribute("closing") && t.finish();
                    const e = t.finished;
                    e.then(() => {
                        this.dispatchEvent(new CustomEvent("dialog:doneClose")),
                            this.parentElement === document.body &&
                                v(this, fe) &&
                                (v(this, fe).appendChild(this), g(this, fe, null)),
                            this.style.setProperty("display", "none"),
                            this.dispatchEvent(new CustomEvent("dialog:afterClose")),
                            this.style.removeProperty("z-index"),
                            this.removeAttribute("closing");
                    }),
                        this.focusTrap?.deactivate({ checkCanReturnFocus: () => e }),
                        this.config.noScroll && (g(this, ce, !1), m(this, le, de).call(this));
                }
            } else {
                g(this, fe, null),
                    this.style.setProperty("display", "block"),
                    (this.style.zIndex = parseInt(this.config.zIndex || 999) + u("[open-dialog]").length),
                    this.dispatchEvent(new CustomEvent("dialog:beforeOpen")),
                    this.config.appendToBody &&
                        this.parentElement !== document.body &&
                        (g(this, fe, this.parentElement), document.body.append(this), ++_e);
                const t = this.animateOpen();
                "immediate" === i && t.finish(),
                    t.finished.then(() => {
                        this.dispatchEvent(new CustomEvent("dialog:afterOpen")), this.setAttribute("opened", "");
                    }),
                    this.config.catchFocus && this.focusTrap.activate({ checkCanFocusTrap: () => t.finished }),
                    this.config.noScroll && (++_e, g(this, ce, !0), m(this, le, de).call(this));
            }
            this.dispatchEvent(new CustomEvent("toggle", { bubbles: !0 }));
        }
    }
    openDialog(t = !0) {
        return this.open
            ? Promise.resolve()
            : (this.setAttribute("open", t ? "" : "immediate"),
              this.setAttribute("open-dialog", ""),
              S(this, "dialog:afterOpen"));
    }
    closeDialog(t = !0) {
        return this.open
            ? (this.setAttribute("closing", t ? "" : "immediate"),
              this.removeAttribute("open"),
              this.removeAttribute("open-dialog"),
              S(this, "dialog:afterClose"))
            : Promise.resolve();
    }
    animateOpen() {
        return mt(this, {}, { duration: 0 });
    }
    animateClose() {
        return mt(this, {}, { duration: 0 });
    }
    get initialFocus() {
        return this.hasAttribute("initial-focus")
            ? "false" !== this.getAttribute("initial-focus") && d(this.getAttribute("initial-focus"), this)
            : this.hasAttribute("tabindex")
              ? this
              : d('input:not([type="hidden"])', this) || !1;
    }
    hideForOutsideClickTarget(t) {
        return !this.contains(t);
    }
    allowOutsideClickForTarget(t) {
        return !1;
    }
    get focusTrap() {
        return g(
            this,
            se,
            v(this, se) ||
                new ut([this, this.shadowRoot], {
                    onDeactivate: this.closeDialog.bind(this),
                    allowOutsideClick: !!this.config.allowOutsideClick && m(this, ue, pe).bind(this),
                    initialFocus: !!_("supports-hover") && this.initialFocus,
                    fallbackFocus: this,
                    preventScroll: this.config.preventScrollFocus,
                })
        );
    }
    selectorPartName(t) {
        return this.shadowRoot?.querySelector(`[part="${t}"]`);
    }
    get stringControls() {
        return `[aria-controls="${this.id}"]:not([section-id])`;
    }
    get allButton() {
        return u(this.stringControls, this.getRootNode());
    }
}
(ce = new WeakMap()),
    (ne = new WeakMap()),
    (se = new WeakMap()),
    (oe = new WeakSet()),
    (he = function (t) {
        if ((t?.preventDefault(), t)) {
            const e = t.target;
            (this.btnOpening = "BUTTON" === e.tagName || "A" === e.tagName ? e : e.closest("button") || e),
                this.btnOpening.hasAttribute("close-dialog") &&
                    c(this.btnOpening.getAttribute("close-dialog"))?.closeDialog(),
                this.btnOpening.hasAttribute("open-mylti") && this.removeAttribute("open");
        }
        this.open ? this.closeDialog() : this.openDialog(!0, this.btnOpening);
    }),
    (le = new WeakSet()),
    (de = function () {
        if (v(this, ce)) t.classList.add("no-scroll");
        else {
            if (_e < 1) return void --_e;
            t.classList.toggle("no-scroll", --_e > 0);
        }
    }),
    (ae = new WeakSet()),
    (re = function (t) {
        ["header", "sticky", "body", "footer"].includes(t.name) &&
            (t.parentElement.hidden = 0 === t.assignedElements({ flatten: !0 }).length);
    }),
    (fe = new WeakMap()),
    (ue = new WeakSet()),
    (pe = function (t) {
        return "TouchEvent" in window && t instanceof TouchEvent
            ? m(this, me, be).call(this, t)
            : m(this, ge, ve).call(this, t);
    }),
    (me = new WeakSet()),
    (be = function (t) {
        return (
            t.target.addEventListener(
                "touchend",
                (t) => {
                    const e = document.elementFromPoint(
                        t.changedTouches.item(0).clientX,
                        t.changedTouches.item(0).clientY
                    );
                    this.hideForOutsideClickTarget(e) && this.closeDialog();
                },
                { once: !0, signal: this.abortController.signal }
            ),
            this.allowOutsideClickForTarget(t.target)
        );
    }),
    (ge = new WeakSet()),
    (ve = function (t) {
        if ("click" !== t.type) return !1;
        if ((this.hideForOutsideClickTarget(t.target) && this.closeDialog(), this.allowOutsideClickForTarget(t.target)))
            return !0;
        let e = t.target,
            i = t.target.closest("[aria-controls]");
        return i && i.getAttribute("aria-controls") === this.id && (e = i), this.id !== e.getAttribute("aria-controls");
    }),
    customElements.define("hdt-dialog", Me);
class Te extends HTMLElement {
    constructor() {
        super(),
            this.addEventListener("click", () =>
                this.dispatchEvent(new CustomEvent("dialog:forceClose", { bubbles: !0, cancelable: !0, composed: !0 }))
            );
    }
}
customElements.define("wrapp-close-btn", Te);
customElements.define(
    "hdt-cart-openable",
    class extends Me {
        animateOpen() {
            let t = this.selectorPartName("content"),
                e = this.selectorPartName("overlay");
            return gt([
                [e, { opacity: [0, 1] }, { duration: 0.15 }],
                [
                    t,
                    { transform: ["translateY(100%)", "translateY(0)"] },
                    { duration: 0.2, easing: "ease-in", at: "-0.075" },
                ],
            ]);
        }
        animateClose() {
            let t = this.selectorPartName("content"),
                e = this.selectorPartName("overlay");
            return gt([
                [t, { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.2, easing: "ease-out" }],
                [e, { opacity: [1, 0] }, { duration: 0.15, at: "-0.1" }],
            ]);
        }
    }
);
import { computePosition as We, shift as Pe, flip as Ie, offset as $e, arrow as Oe } from "vendor";
var He = function (t, e, i, s, n = !0, a = 16, r = "-8px") {
    f(ke, this), f(Ee, this), f(we, this), y(ke, this, xe).call(this, t, e, i, s, n, a, r);
};
(Ae = new Map()),
    f(Ae, C, window.devicePixelRatio || 1),
    (we = new WeakSet()),
    (Ee = new WeakSet()),
    (ke = new WeakSet()),
    (ye = function (t) {
        return Math.round(t * w(Ae, C)) / w(Ae, C);
    }),
    (Ce = function (t, e) {
        return w(Ae, C) > 1
            ? `translate3d(${y(we, this, ye).call(this, t)}px,${y(we, this, ye).call(this, e)}px,0)`
            : `translate(${y(we, this, ye).call(this, t)}px,${y(we, this, ye).call(this, e)}px)`;
    }),
    (xe = function (t, e, i, s, n, a, r) {
        We(t, e, {
            placement: s,
            middleware: [
                $e(parseInt(a)),
                Ie({ fallbackPlacements: ["top", "bottom"] }),
                Pe({ padding: 0 }),
                Oe({ element: i }),
            ],
        }).then(({ x: t, y: s, placement: a, middlewareData: o }) => {
            if (
                ((this.objStyle = n
                    ? { top: "0", left: "0", transform: y(Ee, this, Ce).call(this, t, s) }
                    : { left: `${t}px`, top: `${s}px` }),
                Object.assign(e.style, this.objStyle),
                o.arrow && i)
            ) {
                const { x: t, y: e } = o.arrow,
                    s = { top: "bottom", right: "left", bottom: "top", left: "right" }[a.split("-")[0]];
                Object.assign(i.style, {
                    left: null != t ? `${t}px` : "",
                    top: null != e ? `${e}px` : "",
                    right: "",
                    bottom: "",
                    [s]: r,
                });
            }
        });
    });
customElements.define(
    "hdt-popover",
    class extends Me {
        connectedCallback() {
            super.connectedCallback(),
                this.allButton.forEach((t) => t.setAttribute("aria-haspopup", "dialog")),
                this.config.closeRichlistSelect &&
                    this.addEventListener("richlist:select", this.closeDialog, { signal: this.abortController.signal });
        }
        get defaultTemplate() {
            return "hdt-tmp-popover";
        }
        get userConfig() {
            return Object.assign(
                { noScroll: "smart", appendToBody: "smart" },
                JSON.parse(this.getAttribute("config") || "{}")
            );
        }
        get placement() {
            return this.getAttribute("placement") || "bottom";
        }
        get arrowEl() {
            return this.selectorPartName("arrow");
        }
        updatePos() {
            He.call(this, this.btnOpening, this, this.arrowEl, this.placement);
        }
        animateOpen() {
            let t = this.selectorPartName("content"),
                e = this.selectorPartName("outside-close-button");
            return (
                (this.style.display = "block"),
                _("phone")
                    ? (Object.assign(this.style, {
                          top: null,
                          left: "0px",
                          right: null,
                          bottom: "0px",
                          transform: null,
                      }),
                      gt([
                          [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
                          [
                              t,
                              { clipPath: ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"] },
                              { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
                          ],
                          [t.children, { opacity: [0, 1] }, { duration: 0.15 }],
                          [e, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
                      ]))
                    : (this.updatePos(),
                      gt([
                          [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
                          [t, { clipPath: "none" }, { at: "<", duration: 0 }],
                          [t.children, { opacity: 1 }, { at: "<", duration: 0 }],
                      ]))
            );
        }
        animateClose() {
            if (_("phone")) {
                let t = this.selectorPartName("content"),
                    e = this.selectorPartName("outside-close-button");
                return gt([
                    [e, { opacity: [null, 0] }, { duration: 0.15 }],
                    [t.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
                    [
                        t,
                        { clipPath: [null, "inset(100% 0 0 0 round 8px)"] },
                        { duration: 0.4, easing: [0.86, 0, 0.07, 1] },
                    ],
                    [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }],
                ]);
            }
            return gt(
                this,
                {
                    opacity: [null, 0],
                    visibility: ["visible", "hidden"],
                    transform: ["translateY(0)", "translateY(25%)"],
                },
                { duration: 0.15 }
            );
        }
    }
);
var Ne,
    Re,
    qe,
    De,
    Fe,
    Be,
    Ve,
    ze,
    Ye,
    je,
    Xe,
    Ue,
    Je,
    Ze = "data-original-title";
new WeakMap();
class Qe extends HTMLElement {
    constructor() {
        super(), f(Ne, this), f(De, this), f(qe, this, L());
    }
    connectedCallback() {
        _("supports-hover") &&
            "none" != this.placement &&
            new nt(
                this,
                {
                    onEnter: this.onEnter.bind(this),
                    onExit: this.onExit.bind(this),
                    exitDelay: 0,
                    interval: 80,
                    sensitivity: 6,
                },
                this
            );
    }
    disconnectedCallback() {
        c(w(qe, this))?.remove();
    }
    attributeChangedCallback(t, e, i) {
        e != i &&
            null !== e &&
            this.dispatchEvent(new CustomEvent("theme4:update:tooltip", { bubbles: !0, detail: "the4" }));
    }
    onEnter = () => {
        if (this.innerText.length && this.hasAttribute("will-hidden-txt")) return;
        (this.controller = new AbortController()), y(De, this, Fe).call(this, w(qe, this), y(Ne, this, Re).call(this));
        const t = c(w(qe, this));
        He.call(this, this, t, this.arrowEl, this.placement, !0, 6, "-4px"),
            this.addEventListener(
                "theme4:update:tooltip",
                (e) => {
                    (d(".hdt-tooltip__inner", t).textContent = y(Ne, this, Re).call(this)),
                        He.call(this, this, t, this.arrowEl, this.placement, !0, 6, "-4px");
                },
                { signal: this.controller.signal }
            );
    };
    onExit = () => {
        const t = c(w(qe, this));
        t && (this.controller.abort(), t.remove());
    };
    get placement() {
        return this.getAttribute("placement") || "bottom";
    }
    get arrowEl() {
        return d(".hdt-tooltip__arrow", c(w(qe, this)));
    }
}
(qe = new WeakMap()),
    (Ne = new WeakSet()),
    (Re = function () {
        if (this.hasAttribute("data-txt-tt")) return this.getAttribute("data-txt-tt");
        const t = this.firstElementChild || this;
        let e = (d("[tt-title]", this) || this.lastElementChild || this).textContent;
        return (
            t.hasAttribute("aria-label")
                ? (e = t.getAttribute("aria-label"))
                : t.hasAttribute(Ze)
                  ? (e = t.getAttribute(Ze))
                  : t.hasAttribute("title") &&
                    !t.hasAttribute(Ze) &&
                    ((e = t.getAttribute("title") || ""), t.setAttribute(Ze, e), t.setAttribute("title", "")),
            this.hasAttribute("tt-dynamic") || this.setAttribute("data-txt-tt", (e || "").trim()),
            e
        );
    }),
    (De = new WeakSet()),
    (Fe = function (t, e) {
        document.body.append(
            document
                .createRange()
                .createContextualFragment(
                    `<hdt-tooltip-dialog id="${t}" class="hdt-tooltip" role="tooltip"><div class="hdt-tooltip__arrow"></div><div class="hdt-tooltip__inner">${e}</div></hdt-tooltip-dialog>`
                )
        );
    });
class Ge extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        mt(this, { opacity: [0, 0.9], visibility: ["visible", "visible"] }, { duration: 0.3, easing: "ease" });
    }
}
customElements.define("hdt-tooltip", Qe), customElements.define("hdt-tooltip-dialog", Ge);
class Ke extends HTMLElement {
    constructor() {
        super(), b(this, Be), b(this, ze), this.addEventListener("keydown", m(this, ze, Ye));
    }
    connectedCallback() {
        u('[role="option"]', this).forEach((t) => {
            t.addEventListener("click", m(this, Be, Ve).bind(this));
        });
    }
    static get observedAttributes() {
        return ["selected"];
    }
    set selected(t) {
        this.setAttribute("selected", t);
    }
    attributeChangedCallback(t, e, i) {
        "selected" === t &&
            null !== e &&
            i !== e &&
            u('[role="option"]', this).forEach((t) => {
                t.value === i
                    ? (t.setAttribute("aria-selected", "true"),
                      u(`[aria-owns="${this.id}"]`).forEach((e) => {
                          (d("[change-text]", e) || e).textContent = t.getAttribute("title") || t.innerText || t.value;
                      }),
                      t.dispatchEvent(new CustomEvent("richlist:change", { bubbles: !0, detail: { value: t.value } })))
                    : t.setAttribute("aria-selected", "false");
            });
    }
}
(Be = new WeakSet()),
    (Ve = function (t) {
        const e = t.currentTarget.value;
        (this.selected = e),
            t.currentTarget.dispatchEvent(new CustomEvent("richlist:select", { bubbles: !0, detail: { value: e } }));
    }),
    (ze = new WeakSet()),
    (Ye = function (t) {
        "ArrowUp" === t.key
            ? (t.target.previousElementSibling?.focus(), t.preventDefault())
            : "ArrowDown" === t.key && (t.target.nextElementSibling?.focus(), t.preventDefault());
    }),
    customElements.define("hdt-richlist", Ke);
class ti extends Me {
    connectedCallback() {
        super.connectedCallback(), this.setAttribute("aria-modal", "true");
    }
    get effect() {
        return this.getAttribute("effect") || "fade";
    }
    get defaultTemplate() {
        return "hdt-tmp-modal";
    }
    animateOpen() {
        return _("phone")
            ? gt([
                  [
                      this.selectorPartName("overlay"),
                      { opacity: [0, 1] },
                      { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
                  ],
                  [
                      this.selectorPartName("content"),
                      { transform: ["translateY(100%)", "translateY(0)"] },
                      { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
                  ],
              ])
            : "fade" == this.effect
              ? mt(this, { opacity: [0, 1] }, { duration: 0.2 })
              : gt([
                    [
                        this.selectorPartName("overlay"),
                        { opacity: [0, 1] },
                        { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
                    ],
                    [
                        this.selectorPartName("content"),
                        { transform: ["translateX(-200px)", "translateX(0)"], opacity: [0, 1] },
                        { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
                    ],
                    [
                        this.selectorPartName("close-button"),
                        { opacity: [0, 1] },
                        { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
                    ],
                ]);
    }
    animateClose() {
        return _("phone")
            ? gt([
                  [
                      this.selectorPartName("overlay"),
                      { opacity: [1, 0] },
                      { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
                  ],
                  [
                      this.selectorPartName("content"),
                      { transform: ["translateY(0)", "translateY(100%)"] },
                      { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
                  ],
              ])
            : "fade" == this.effect
              ? mt(this, { opacity: [1, 0] }, { duration: 0.2 })
              : gt([
                    [
                        this.selectorPartName("overlay"),
                        { opacity: [1, 0] },
                        { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
                    ],
                    [
                        this.selectorPartName("content"),
                        { transform: ["translateX(0)", "translateX(200px)"], opacity: [1, 0] },
                        { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
                    ],
                    [
                        this.selectorPartName("close-button"),
                        { opacity: [1, 0] },
                        { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] },
                    ],
                ]);
    }
}
customElements.define("hdt-modal", ti);
class ei extends ti {
    get defaultTemplate() {
        return "hdt-tmp-drawer";
    }
    get effect() {
        let t = this.getAttribute("effect-lg");
        return !t || _("phone") || _("tablet") ? this.getAttribute("effect") || "left" : t;
    }
    get codeEffect() {
        switch (this.effect) {
            case "left":
                return ["translateX(calc(var(--value-logical-flip) * -100%))", "translateX(0)"];
            case "right":
                return ["translateX(calc(var(--value-logical-flip) * 100%))", "translateX(0)"];
            case "top":
                return ["translateY(-100%)", "translateY(0)"];
            default:
                return ["translateY(100%)", "translateY(0)"];
        }
    }
    animateOpen() {
        this.selectorPartName("content").style.marginInlineStart = "right" === this.effect ? "auto" : 0;
        const t = this.codeEffect;
        return gt([
            [
                this.selectorPartName("overlay"),
                { opacity: [0, 1] },
                { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] },
            ],
            [
                this.selectorPartName("footer"),
                { opacity: [0, 1] },
                { duration: 0.6, easing: [0.645, 0.045, 0.355, 1], at: "<" },
            ],
            [this.selectorPartName("content"), { transform: t }, { duration: 0.3, at: "<", easing: "ease" }],
            [
                this.selectorPartName("outside-close-button"),
                { opacity: [0, 1] },
                { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] },
            ],
        ]);
    }
    animateClose() {
        const t = this.codeEffect.reverse();
        return gt([
            [this.selectorPartName("footer"), { opacity: [1, 0] }, { duration: 0.6, easing: [0.645, 0.045, 0.355, 1] }],
            [this.selectorPartName("content"), { transform: t }, { duration: 0.3, at: "<", easing: "ease" }],
            [
                this.selectorPartName("outside-close-button"),
                { opacity: [1, 0] },
                { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] },
            ],
            [
                this.selectorPartName("overlay"),
                { opacity: [1, 0] },
                { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" },
            ],
        ]);
    }
}
customElements.define("hdt-drawer", ei);
class ii extends HTMLElement {
    constructor() {
        super(), f(je, this), f(Ue, this);
    }
    connectedCallback() {
        d(".hdt-bf__range", this).addEventListener("input", y(Ue, this, Je).bind(this)),
            (this.beforeVal = d(".hdt-bf__range", this).value),
            vt(this, y(je, this, Xe).bind(this), { margin: "0px 0px -44% 0px" });
    }
}
(je = new WeakSet()),
    (Xe = function (t) {
        mt(
            (t) => {
                this.style.setProperty("--percent-val", this.beforeVal * t);
            },
            { duration: 0.6, easing: [0.85, 0, 0.15, 1] }
        );
    }),
    (Ue = new WeakSet()),
    (Je = function (t) {
        this.style.setProperty("--percent-val", t.target.value);
    }),
    customElements.define("hdt-before-after", ii);
class si extends HTMLElement {
    timezoneString = themeHDN.settings.shopTimezone ? ` GMT${themeHDN.settings.shopTimezone}` : "";
    constructor() {
        super(),
            (this.selectors = {
                days: "[data-days]",
                hours: "[data-hours]",
                minutes: "[data-minutes]",
                seconds: "[data-seconds]",
            }),
            (this.classes = { enabled: "hdt-cd--enabled", hide: "hdt-cd--hide", complete: "hdt-cd--complete" }),
            (this.arrayMth = {
                1: "january",
                2: "february",
                3: "march",
                4: "april",
                5: "may",
                6: "june",
                7: "july",
                8: "august",
                9: "september",
                10: "october",
                11: "november",
                12: "december",
            }),
            (this.defaults = { idTmp: null, hasZero: !0, hideTimerOnComplete: !0 }),
            cancelAnimationFrame(this.myReq);
        const t = Object.assign({}, this.defaults, JSON.parse(this.getAttribute("config") || "{}"));
        if (
            ((this.date = new Date(Date.parse(this.arrayMth[t.month] + " " + t.date + this.timezoneString))),
            !isNaN(this.date))
        ) {
            if (
                ((this.hideTimerOnComplete = t.hideTimerOnComplete),
                (this.countDownTime = this.date.getTime()),
                t.idTmp)
            ) {
                const e = c(t.idTmp);
                e && (this.innerHTML = e.innerHTML);
            }
            (this.daysEl = d(this.selectors.days, this)),
                (this.hoursEl = d(this.selectors.hours, this)),
                (this.minutesEl = d(this.selectors.minutes, this)),
                (this.secondsEl = d(this.selectors.seconds, this)),
                (this.hasZero = t.hasZero),
                (this.playing = !1),
                this.init(),
                vt(
                    this,
                    (t) => (
                        this.play(),
                        (this.isInview = !0),
                        (t) => {
                            this.pause(), (this.isInview = !1);
                        }
                    ),
                    { margin: "0px 0px 150px 0px" }
                ),
                H({ observes: this, play: this.play.bind(this), pause: this.pause.bind(this) });
        }
    }
    init() {
        this.playing || (this.myReq || this.classList.add(this.classes.enabled), this.play());
    }
    timerLoop() {
        const t = new Date().getTime(),
            e = this.countDownTime - t,
            i = Math.floor(e / 864e5);
        let s = Math.floor((e % 864e5) / 36e5);
        const n = Math.floor((e % 36e5) / 6e4),
            a = Math.floor((e % 6e4) / 1e3);
        e < 0
            ? (this.destroy(),
              this.classList.add(this.classes.complete),
              this.hideTimerOnComplete && this.classList.add(this.classes.hide))
            : (this.daysEl || (s += 24 * i),
              this.daysEl?.updateValue(i, this.hasZero),
              this.hoursEl?.updateValue(s, this.hasZero),
              this.minutesEl?.updateValue(n, this.hasZero),
              this.secondsEl?.updateValue(a, this.hasZero),
              (this.myReq = requestAnimationFrame(this.timerLoop.bind(this))));
    }
    play() {
        this.playing || ((this.myReq = requestAnimationFrame(this.timerLoop.bind(this))), (this.playing = !0));
    }
    pause() {
        this.playing && (cancelAnimationFrame(this.myReq), (this.playing = !1));
    }
    destroy() {
        this.pause(), this.classList.remove(this.classes.enabled);
    }
}
class ni extends HTMLElement {
    constructor() {
        super(), this.attachShadow({ mode: "open" });
        let t = [...this.textContent].map(
            () =>
                `<hdt-countdown-number part="number" effect="${this.getAttribute("effect")}" style="display: inline-block">0</hdt-countdown-number>`
        );
        this.shadowRoot.appendChild(document.createRange().createContextualFragment(t.join("")));
    }
    updateValue(t, e) {
        let i = Math.min(99, t).toString().padStart(2, "0");
        if (
            ((this.textContent = i),
            [...i].forEach((t, e) => {
                this.shadowRoot.children[e].setAttribute("number", t);
            }),
            this.nextElementSibling && this.nextElementSibling.shadowRoot)
        ) {
            let t = 0;
            for (; t < 2; t++) this.nextElementSibling.shadowRoot.children[t].setAttribute("amount", i);
        }
        e || (this.shadowRoot.children[0].style.display = i < 10 ? "none" : "inline-block");
    }
}
class ai extends HTMLElement {
    static observedAttributes = ["number"];
    constructor() {
        switch ((super(), (this.e = { Y: 0, S: 1, R: 0 }), (this.runFrist = 0), this.getAttribute("effect"))) {
            case "move_top":
                (this.e.Y = -8), (this.e.Y2 = 8);
                break;
            case "move_bottom":
                (this.e.Y = 6), (this.e.Y2 = -6);
                break;
            case "scale":
                this.e.S = 0.5;
                break;
            case "rotate":
                (this.e.R = 180), (this.e.S = 0.68);
        }
        this.attachShadow({ mode: "open" }).appendChild(
            document.createRange().createContextualFragment("<div><slot></slot></div>")
        );
    }
    async attributeChangedCallback(t, e, i) {
        if ((++this.runFrist, "none" == this.getAttribute("effect") || 2 == this.runFrist))
            return (this.textContent = i);
        null !== e &&
            e !== i &&
            (await mt(
                this.shadowRoot.firstElementChild,
                {
                    opacity: [1, 0],
                    transform: [
                        "translateY(0) rotate(0deg) scale(1)",
                        `translateY(${this.e.Y}px) rotate(${this.e.R}deg) scale(${this.e.S})`,
                    ],
                },
                { duration: 0.25, easing: [0.64, 0, 0.78, 0] }
            ).finished,
            (this.textContent = i),
            mt(
                this.shadowRoot.firstElementChild,
                {
                    opacity: [0, 1],
                    transform: [
                        `translateY(${this.e.Y2 || this.e.Y}px) rotate(${this.e.R}deg) scale(${this.e.S})`,
                        "translateY(0) rotate(0deg) scale(1)",
                    ],
                },
                { duration: 0.25, delay: 0.1, easing: [0.22, 1, 0.36, 1] }
            ));
    }
}
class ri extends HTMLElement {
    static observedAttributes = ["amount"];
    constructor() {
        if ((super(), !this.hasAttribute("singular"))) return;
        this.attachShadow({ mode: "open" });
        let t = 0,
            e = "";
        for (; t < 2; t++)
            e += `<hdt-countdown-unit ${t ? "singular" : "plural"} part="unit" style="grid-area: 1 / -1; will-change: opacity; opacity: ${t ? 0 : 1};">${t ? this.getAttribute("singular") : this.textContent}</hdt-countdown-unit>`;
        this.shadowRoot.appendChild(document.createRange().createContextualFragment(e));
    }
}
class oi extends HTMLElement {
    static observedAttributes = ["amount"];
    constructor() {
        super();
    }
    async attributeChangedCallback(t, e, i) {
        e !== i && (this.style.opacity = this.hasAttribute("plural") ? (1 == i ? 0 : 1) : 1 == i ? 1 : 0);
    }
}
customElements.define("hdt-countdown", si),
    customElements.define("hdt-countdown-amount", ni),
    customElements.define("hdt-countdown-number", ai),
    customElements.define("hdt-countdown-text", ri),
    customElements.define("hdt-countdown-unit", oi);
var hi,
    li,
    di = new WeakMap(),
    ci = new WeakMap(),
    ui = new WeakMap(),
    pi = new WeakSet();
class mi extends HTMLElement {
    #t;
    constructor() {
        super(),
            f(di, this, d("details", this)),
            f(ci, this, d("summary", this)),
            f(ui, this, w(ci, this).nextElementSibling),
            f(pi, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            w(ci, this).addEventListener("click", this._onSummaryClicked.bind(this), { signal: this.#t.signal }),
            w(ci, this).addEventListener("pick", this._onSummaryClicked.bind(this), { signal: this.#t.signal }),
            w(di, this).addEventListener("keydown", y(pi, this, hi).bind(this), { signal: this.#t.signal }),
            Shopify.designMode &&
                (this.addEventListener(s, () => this.toggle(), { signal: this.#t.signal }),
                this.addEventListener(n, () => this.toggle(!1), { signal: this.#t.signal }));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get open() {
        return w(di, this).hasAttribute("open");
    }
    toggle(t = !0) {
        ((t && !this.open) || (!t && this.open)) &&
            w(ci, this)?.dispatchEvent(new CustomEvent("pick", { detail: { offClick: !0 } }));
    }
    _onSummaryClicked(t) {
        if (
            (t.preventDefault(),
            !t?.detail?.offClick &&
                w(ci, this).hasAttribute("data-url") &&
                this.hasAttribute("only-click-icon") &&
                !t.target.hasAttribute("accordion-icon"))
        )
            return (window.location.href = w(ci, this).getAttribute("data-url"));
        (w(di, this).style.overflow = "hidden"),
            w(ci, this).setAttribute("aria-expanded", `${!this.open}`),
            this.open
                ? gt([
                      [w(ui, this), { opacity: 0 }, { duration: 0.15 }],
                      [
                          w(di, this),
                          { height: [`${w(di, this).clientHeight}px`, `${w(ci, this).clientHeight}px`] },
                          { duration: 0.25, at: "<", easing: "ease" },
                      ],
                  ]).finished.then(() => {
                      (w(di, this).style.height = null),
                          (w(di, this).style.overflow = null),
                          w(di, this).removeAttribute("open");
                  })
                : (w(di, this).setAttribute("open", ""),
                  gt([
                      [
                          w(di, this),
                          { height: [`${w(ci, this).clientHeight}px`, `${w(di, this).scrollHeight}px`] },
                          { duration: 0.25, easing: "ease" },
                      ],
                      [
                          w(ui, this),
                          { opacity: [0, 1], transform: ["translateY(4px)", "translateY(0)"] },
                          { duration: 0.15, at: "-0.1" },
                      ],
                  ]).finished.then(() => {
                      (w(di, this).style.height = null), (w(di, this).style.overflow = null);
                  }));
    }
}
(hi = function (t) {
    "Enter" == t.key &&
        t.target?.hasAttribute("accordion-icon") &&
        (t.preventDefault(), t.stopPropagation(), t.target.click());
}),
    customElements.define("hdt-accordion", mi);
class bi extends HTMLElement {
    #t;
    connectedCallback() {
        this.idControls &&
            ((this.buttons = u("button", this)),
            (this.items = u("[tab-item]", this.idControls)),
            (this.#t = new AbortController()),
            (this.oldIndex = 0),
            this.buttons.forEach((t) =>
                t.addEventListener("click", () => this._onButtonClicked(t, this.buttons.indexOf(t)), {
                    signal: this.#t.signal,
                })
            ),
            Shopify.designMode && this.addEventListener(s, (t) => t.target.click()));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get idControls() {
        return c(this.getAttribute("aria-controls"));
    }
    animateHide() {
        return mt(
            this.items[this.oldIndex],
            { opacity: [1, 0], transform: ["translateY(0px)", "translateY(19px)"] },
            { duration: 0.2, easing: "ease-in" }
        );
    }
    animateShow(t) {
        return mt(
            this.items[t],
            { opacity: [0, 1], transform: ["translateY(19px)", "translateY(0px)"] },
            { duration: 0.1, delay: 0.1, easing: "ease-out" }
        );
    }
    _onButtonClicked(t, e) {
        if ("true" === t.getAttribute("aria-current")) return;
        this.buttons.forEach((t, i) => t.setAttribute("aria-current", (e == i).toString()));
        this.animateHide().finished.then(() => {
            this.items[this.oldIndex].removeAttribute("tab-selected"),
                (this.oldIndex = e),
                this.items[e].setAttribute("tab-selected", ""),
                this.animateShow(e);
        });
    }
}
customElements.define("hdt-tab", bi);
class gi extends HTMLElement {
    constructor() {
        super(),
            (this.classes = { enabled: "hdt-marquee--enabled", duplicate: "hdt-marquee--duplicate" }),
            (this.oldWidth = 0),
            this.attachShadow({ mode: "open" }).appendChild(
                document.createRange().createContextualFragment("<slot part='wrapper'></slot>")
            ),
            this.init();
        new ResizeObserver((t) => this.init()).observe(this),
            _("motion") &&
                (vt(
                    this,
                    (t) => (
                        this.animation.play(),
                        (this.isInview = !0),
                        (t) => {
                            this.animation.pause(), (this.isInview = !1);
                        }
                    ),
                    { margin: "250px" }
                ),
                H({ observes: this, play: this.animation.play, pause: this.animation.pause }));
    }
    get wrapper() {
        return w(li, this, this.shadowRoot.querySelector('[part="wrapper"]'));
    }
    init() {
        this.clientWidth < this.oldWidth ||
            ((this.oldWidth = this.clientWidth), this.prepareContent(), this.calculateWidthRatio());
    }
    prepareContent() {
        this.classList.remove(this.classes.enabled);
        var t = u("." + this.classes.duplicate, this);
        t.length && t.forEach((t) => t.remove());
    }
    calculateWidthRatio() {
        let t,
            e,
            i = Math.ceil(this.clientWidth / this.firstElementChild.offsetWidth) + 1;
        const s = document.createDocumentFragment();
        for (e = 0; e < i; e++)
            (t = this.firstElementChild.cloneNode(!0)),
                t.setAttribute("aria-hidden", !0),
                t.classList.add(this.classes.duplicate),
                t.style.setProperty("--index", e + 1),
                s.appendChild(t);
        this.append(s),
            this.classList.add(this.classes.enabled),
            _("motion") &&
                ((this.animation = mt(
                    this.wrapper,
                    {
                        transform: [
                            "translateX(0)",
                            "translateX(calc(var(--value-logical-flip) * var(--dir-logical) * 100%))",
                        ],
                    },
                    {
                        duration: (1 / parseFloat(this.getAttribute("speed"))) * (this.wrapper.clientWidth / 350),
                        easing: "linear",
                        repeat: 1 / 0,
                    }
                )),
                this.hasAttribute("pause-on-pointer-enter") &&
                    (this.addEventListener("mouseenter", this.onmouseenter),
                    this.addEventListener("touchstart", this.onmouseenter)));
    }
    onmouseenter() {
        this.animation.pause(),
            this.addEventListener("mouseleave", this.onmouseleave),
            this.addEventListener("touchend", this.onmouseleave);
    }
    onmouseleave() {
        this.animation.play(),
            this.removeEventListener("mouseleave", this.onmouseleave),
            this.removeEventListener("touchend", this.onmouseleave);
    }
    disconnectedCallback() {
        E(li, this),
            this.removeEventListener("mouseenter", this.onmouseenter),
            this.removeEventListener("touchstart", this.onmouseenter);
    }
}
(li = new WeakMap()), customElements.define("hdt-marquee", gi);
var vi,
    fi,
    wi,
    yi,
    Ei = new WeakMap();
class Ci extends HTMLElement {
    constructor() {
        super(), f(vi, this), f(Ei, this, d("picture img, img", this));
    }
    connectedCallback() {
        _("motion") && w(Ei, this) && y(vi, this, fi).call(this);
    }
}
(vi = new WeakSet()),
    (fi = function () {
        const t = this.getAttribute("eff");
        if ("ambient" === t)
            mt(
                w(Ei, this),
                {
                    transform: [
                        "rotate(0deg) translateX(1em) rotate(0deg) scale(1.2)",
                        "rotate(360deg) translateX(1em) rotate(-360deg) scale(1.2)",
                    ],
                },
                { duration: 30, easing: "linear", repeat: 1 / 0 }
            );
        else if ("parallax" === t) {
            const t = parseFloat(this.style.getPropertyValue("--parallax-scale") || 1.3),
                [e, i] = [t, 15 / t],
                s = this.closest(".hdt-section").matches(":first-child");
            bt(
                mt(
                    w(Ei, this),
                    { transform: [`scale(${e}) translateY(-${i}%)`, `scale(${e}) translateY(${i}%)`] },
                    { easing: "linear" }
                ),
                { target: w(Ei, this), offset: [s ? "start start" : "start end", "end start"] }
            );
        }
    }),
    customElements.define("hdt-effect-img", Ci);
class ki extends HTMLElement {
    constructor() {
        super(), f(wi, this), window.ResizeObserver && new ResizeObserver(x(y(wi, this, yi).bind(this))).observe(this);
    }
    connectedCallback() {
        window.ResizeObserver ||
            t.style.setProperty(`--${this.getAttribute("prefix")}-height`, `${Math.round(this.clientHeight)}px`);
    }
}
(wi = new WeakSet()),
    (yi = function (e) {
        e.forEach((e) => {
            if (e.target === this) {
                const i = e.borderBoxSize
                    ? e.borderBoxSize.length > 0
                        ? e.borderBoxSize[0].blockSize
                        : e.borderBoxSize.blockSize
                    : e.target.clientHeight;
                t.style.setProperty(`--${this.getAttribute("prefix")}-height`, `${Math.round(i)}px`);
            }
        });
    }),
    customElements.define("hdt-height-observer", ki);
customElements.define(
    "hdt-sticky-header",
    class extends ki {
        constructor() {
            super();
        }
        connectedCallback() {
            this.checkTransparent(),
                super.connectedCallback(),
                (this.stickyType = this.getAttribute("sticky-type")),
                "none" !== this.stickyType &&
                    ((this.header = this.closest(".hdt-section-header")),
                    (this.headerIsAlwaysSticky = "always" === this.stickyType),
                    (this.headerBounds = {}),
                    this.headerIsAlwaysSticky && this.header.classList.add("shopify-section-header-sticky"),
                    (this.currentScrollTop = 0),
                    (this.preventReveal = !1),
                    (this.predictiveSearch = d("predictive-search", this)),
                    (this.onScrollHandler = this.onScroll.bind(this)),
                    (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
                    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
                    window.addEventListener("scroll", this.onScrollHandler, !1),
                    this.createObserver());
        }
        disconnectedCallback() {
            this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
                window.removeEventListener("scroll", this.onScrollHandler);
        }
        createObserver() {
            new IntersectionObserver((t, e) => {
                (this.headerBounds = t[0].intersectionRect), e.disconnect();
            }).observe(this.header);
        }
        onScroll() {
            const e = window.scrollY || t.scrollTop;
            if (!this.predictiveSearch || !this.predictiveSearch.isOpen) {
                if (e > this.currentScrollTop && e > this.headerBounds.bottom) {
                    if ((this.header.classList.add("scrolled-past-header"), this.preventHide)) return;
                    requestAnimationFrame(this.hide.bind(this));
                } else
                    e < this.currentScrollTop && e > this.headerBounds.bottom
                        ? (this.header.classList.add("scrolled-past-header"),
                          this.preventReveal
                              ? (window.clearTimeout(this.isScrolling),
                                (this.isScrolling = setTimeout(() => {
                                    this.preventReveal = !1;
                                }, 66)),
                                requestAnimationFrame(this.hide.bind(this)))
                              : requestAnimationFrame(this.reveal.bind(this)))
                        : e <= this.headerBounds.top &&
                          (this.header.classList.remove("scrolled-past-header"),
                          requestAnimationFrame(this.reset.bind(this)));
                this.currentScrollTop = e;
            }
        }
        hide() {
            this.headerIsAlwaysSticky ||
                (this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky"),
                this.closeMenuDisclosure());
        }
        reveal() {
            this.headerIsAlwaysSticky ||
                (this.header.classList.add("shopify-section-header-sticky", "animate"),
                this.header.classList.remove("shopify-section-header-hidden"));
        }
        reset() {
            this.headerIsAlwaysSticky ||
                this.header.classList.remove(
                    "shopify-section-header-hidden",
                    "shopify-section-header-sticky",
                    "animate"
                );
        }
        closeMenuDisclosure() {
            u("hdt-header-menu > details[open]", this.header).forEach((t) => t.parentElement.toggle(!1));
        }
        checkTransparent() {
            d(".section-allow-transparent.hdt-section:first-child") &&
                !d(".hdt-section-header + .shopify-section-group-header-group") &&
                t.setAttribute("enabled-transparent-header", "");
        }
    }
);
var xi,
    Ai,
    Si,
    Li,
    _i,
    Mi,
    Ti,
    Wi,
    Pi,
    Ii = new WeakMap(),
    $i = new WeakMap();
(xi = new WeakMap()),
    (Ai = new WeakMap()),
    (Si = new WeakMap()),
    (Li = new WeakMap()),
    (_i = new WeakMap()),
    (Mi = new WeakSet()),
    (Wi = new WeakSet()),
    (Ti = function (t) {
        "click" === this.event && (this.contains(t.target) || this.toggle(!1));
    }),
    (Pi = function (t) {
        if ("Escape" === t.code) {
            t.target.closest("details[open]") && (this.toggle(!1), t.stopPropagation());
        }
    }),
    customElements.define(
        "hdt-header-menu",
        class extends mi {
            constructor() {
                super(),
                    _("phone") ||
                        ("hover" === this.event &&
                            new nt(
                                w(di, this),
                                {
                                    onEnter: (t) => {
                                        w(ci, this).classList.add("is_action-hover"), this.toggle();
                                    },
                                    onExit: (t) => {
                                        w(ci, this).classList.remove("is_action-hover"), this.toggle(!1);
                                    },
                                    exitDelay: 150,
                                    interval: 35,
                                    sensitivity: 3,
                                },
                                w(ci, this)
                            ),
                        f(Mi, this),
                        f(Wi, this),
                        f($i, this, y(Wi, this, Pi).bind(this)),
                        f(Ii, this, y(Mi, this, Ti).bind(this)));
            }
            get expanded() {
                return "true" === w(ci, this).getAttribute("aria-expanded");
            }
            get event() {
                return w(xi, this, _("supports-hover") ? this.getAttribute("event") : "click");
            }
            get position() {
                return w(Ai, this, this.getAttribute("position") || "bottom");
            }
            get isCenterOnScreen() {
                return w(Si, this, "center_on_screen" === this.position);
            }
            get needCalc() {
                return w(_i, this, !w(di, this).hasAttribute("not-need-calc"));
            }
            get x() {
                return w(Li, this, this.isCenterOnScreen ? "-50%" : "0");
            }
            _onSummaryClicked(t) {
                if (
                    !t?.detail?.offClick &&
                    w(ci, this).hasAttribute("data-url") &&
                    ("hover" === this.event || (this.expanded && this.hasAttribute("opened-able-click")))
                )
                    return (window.location.href = w(ci, this).getAttribute("data-url"));
                t.preventDefault(),
                    w(ci, this).setAttribute("aria-expanded", `${!this.open}`),
                    this.open
                        ? (document.removeEventListener("click", w(Ii, this)),
                          document.removeEventListener("keydown", w($i, this)),
                          gt([
                              [
                                  w(ui, this),
                                  {
                                      opacity: [1, 0],
                                      visibility: ["visible", "hidden"],
                                      transform: [
                                          `translateX(${this.x}) translateY(0)`,
                                          `translateX(${this.x}) translateY(15px)`,
                                      ],
                                  },
                                  { duration: 0.4, easing: [0.19, 1, 0.22, 1] },
                              ],
                          ]).finished.then(() => {
                              w(di, this).removeAttribute("open");
                          }))
                        : (document.addEventListener("click", w(Ii, this)),
                          document.addEventListener("keydown", w($i, this)),
                          w(di, this).setAttribute("open", ""),
                          this.needCalc &&
                              !this.isCenterOnScreen &&
                              He.call(this, w(ci, this), w(ui, this), null, this.position, !1),
                          gt([
                              [
                                  w(ui, this),
                                  {
                                      opacity: [0, 1],
                                      visibility: ["hidden", "visible"],
                                      transform: [
                                          `translateX(${this.x}) translateY(15px)`,
                                          `translateX(${this.x}) translateY(0)`,
                                      ],
                                  },
                                  { duration: 0.4, easing: [0.19, 1, 0.22, 1] },
                              ],
                          ]).finished.then(() => {}));
            }
        }
    );
var Oi,
    Hi,
    Ni,
    Ri,
    qi,
    Di,
    Fi,
    Bi,
    Vi,
    zi,
    Yi,
    ji,
    Xi,
    Ui,
    Ji,
    Zi,
    Qi,
    Gi,
    Ki,
    ts,
    es,
    is,
    ss = "is--color-limit",
    ns = new WeakMap();
class as extends HTMLElement {
    constructor() {
        super(),
            f(Yi, this, new pt(this)),
            f(Xi, this),
            f(Gi, this),
            f(ts, this),
            f(Ji, this, this.closest(".hdt-card-product")),
            f(Zi, this, u("[data-pr-url]", w(Ji, this))),
            f(ns, this, d("fieldset", this));
    }
    connectedCallback() {
        if (
            (u('[type="radio"]:not([disabled])', this).length > 0 &&
                (w(Yi, this).on("change", '[type="radio"]', y(Xi, this, Ui).bind(this)),
                w(Yi, this).on("pointerover", '[type="radio"][data-vimg] + label', y(Gi, this, Ki).bind(this), !0),
                _("phone") ||
                    "hover" != this.event ||
                    u('[type="radio"] + label', this).forEach((t) => {
                        new nt(t, {
                            onEnter: (t) => t.click(),
                            onExit: (t) => {},
                            exitDelay: 100,
                            interval: 100,
                            sensitivity: 6,
                        });
                    })),
            w(ns, this).childElementCount > 2)
        ) {
            if (
                (f(Fi, this, 0),
                f(Ni, this, w(ns, this).firstChild),
                f(Ri, this, w(ns, this).lastChild),
                f(qi, this),
                f(zi, this, this.closest(".hdt-slider__products")),
                this.hasAttribute("auto-limit"))
            )
                if ((f(Oi, this), window.ResizeObserver)) {
                    let t = new ResizeObserver(x(y(qi, this, Di).bind(this)));
                    t.observe(this),
                        this.addEventListener("unobserve", () => {
                            t.unobserve(this), (t = null);
                        });
                } else y(Oi, this, Hi).call(this);
            if (
                this.hasAttribute("action-all") &&
                (f(Bi, this),
                w(Ri, this).addEventListener("click", y(Bi, this, Vi).bind(this)),
                window.ResizeObserver && !this.hasAttribute("auto-limit"))
            ) {
                let t = new ResizeObserver(x(y(qi, this, Di).bind(this)));
                t.observe(this),
                    this.addEventListener("unobserve2", () => {
                        t.unobserve(this), (t = null);
                    });
            }
        }
    }
    disconnectedCallback() {
        w(Yi, this).off();
    }
    get event() {
        return w(ji, this, _("supports-hover") ? this.getAttribute("event") : "click");
    }
}
(Oi = new WeakSet()),
    (Ni = new WeakMap()),
    (Ri = new WeakMap()),
    (qi = new WeakSet()),
    (Bi = new WeakSet()),
    (Fi = new WeakMap()),
    (zi = new WeakMap()),
    (Yi = new WeakMap()),
    (ji = new WeakMap()),
    (Xi = new WeakSet()),
    (Ji = new WeakMap()),
    (Zi = new WeakMap()),
    (Qi = new WeakMap()),
    (is = new WeakMap()),
    (Hi = function () {
        const t = w(Ni, this).getBoundingClientRect().width,
            e = w(Ri, this).getBoundingClientRect().width,
            i = getComputedStyle(w(ns, this)),
            s = parseFloat(i.gap || i.columnGap || 10),
            n = w(ns, this).childElementCount - 1,
            a = t * n + (n - 1) * s,
            { width: r } = w(ns, this).getBoundingClientRect(),
            o = Math.floor(r / (t + s)),
            h = Math.floor((r - e) / (t + s));
        o >= n || a <= w(Fi, this)
            ? (w(Ri, this).setAttribute("hidden", ""), d("." + ss, this)?.classList.remove(ss))
            : (w(ns, this).childNodes[h]?.classList.add(ss),
              d("." + ss, this)?.classList.remove(ss),
              (w(Ri, this).lastElementChild.textContent = "+" + (n - h)),
              (w(Ri, this).style.opacity = 1));
    }),
    (Di = function (t) {
        w(zi, this) && w(At, w(zi, this)).reInit(),
            w(Fi, this) != t[0].contentRect.width &&
                (f(Fi, this, t[0].contentRect.width, !0),
                this.hasAttribute("auto-limit")
                    ? (d("." + ss, this)?.classList.remove(ss),
                      w(ns, this).childNodes[1]?.classList.add(ss),
                      w(Ri, this).removeAttribute("hidden"),
                      (w(Ri, this).style.opacity = 0),
                      y(Oi, this, Hi).call(this))
                    : (w(ns, this).childNodes[parseInt(this.getAttribute("maximum"))]?.classList.add(ss),
                      w(Ri, this).removeAttribute("hidden")));
    }),
    (Vi = function (t) {
        t.preventDefault(),
            this.dispatchEvent(new CustomEvent("unobserve", { cancelable: !0, composed: !0 })),
            this.dispatchEvent(new CustomEvent("unobserve2", { cancelable: !0, composed: !0 }));
        const e = d("." + ss, this);
        e?.classList.remove(ss),
            w(Ri, this).setAttribute("hidden", ""),
            (this.style.minHeight = this.clientHeight + "px"),
            mt(
                w(ns, this).children,
                { opacity: [0, 1], transform: ["scale(.5) translateY(10px)", "scale(1) translateY(0)"] },
                { duration: 0.35, delay: ft(0.05, { easing: "ease-out" }), easing: "ease" }
            ).finished.then(() => {
                (this.style.minHeight = null), w(zi, this) && w(At, w(zi, this)).reInit();
            }),
            e?.previousElementSibling.querySelector("input")?.focus();
    }),
    (Ui = function (t, e) {
        if (w(Zi, this).length) {
            const t = os.get(w(Qi, this, w(Zi, this)[0].href), e.dataset.vid);
            w(Zi, this).forEach((e) => {
                e.href = t;
            });
        }
        const i = w(is, e, e.getAttribute("data-vimg"));
        if (i) {
            const t = w(Ji, this).querySelector(".hdt-card-product__media--main");
            if (i === t.getAttribute("src")) return;
            t.parentElement.removeAttribute("loaded"),
                t.parentElement.setAttribute("loading", ""),
                t.replaceWith(y(ts, this, es).call(this, i, t));
        }
    }),
    (Gi = new WeakSet()),
    (Ki = function (t, e) {
        const i = e.previousElementSibling;
        if (!i) return;
        const s = w(is, i, i.getAttribute("data-vimg"));
        if (s) {
            const t = w(Ji, this).querySelector(".hdt-card-product__media--main");
            s !== t.getAttribute("src") && y(ts, this, es).call(this, s, t);
        }
    }),
    (ts = new WeakSet()),
    (es = function (t, e) {
        return M({
            src: t,
            width: e.getAttribute("width"),
            height: e.getAttribute("height"),
            alt: e.alt,
            onload: !0,
            attrs: { class: e.className, sizes: e.sizes, "data-widths": e.getAttribute("data-widths") || "[]" },
        });
    }),
    customElements.define("wrapp-hdt-color-list", as);
var rs = {},
    os = class {
        static get(t, e) {
            if (t && e)
                return rs[e] ? rs[e] : ((t = new URL(t)).searchParams.set("variant", e), (rs[e] = t.toString()));
        }
    };
const { currencyFormat: hs } = themeHDN.settings,
    ls = "variant:change";
var ds,
    cs,
    us = new WeakMap();
(ds = new WeakSet()),
    (cs = function () {
        this.innerHTML = "";
    });
class ps extends HTMLElement {
    constructor() {
        super(), this.getIDTemp(), this.addEventListener("theme:update:id", () => this.getIDTemp());
    }
    async getIDTemp() {
        const t = d('[aria-controls="hdt-quick-view-modal"], [aria-controls="hdt-quick-add-modal"]');
        if (!t || this.hasID) return;
        (this.hasID = !0), this.removeEventListener("theme:update:id", () => this.getIDTemp());
        let e,
            i = "themeQuick" + window.Shopify.theme.id;
        sessionStorage.getItem(i) && !Shopify.designMode
            ? (e = sessionStorage.getItem(i))
            : ((e = await (
                  await fetch(`${window.Shopify.routes.root}products/${t.getAttribute("handle")}?view=only_config`, {
                      priority: "low",
                  })
              ).text()),
              sessionStorage.setItem(i, e));
        const s = new DOMParser().parseFromString(e, "text/html");
        u(".hdt-main-section--quick-view, .hdt-main-section--quick-add", s).forEach((t) =>
            this.insertAdjacentHTML("afterend", t.innerHTML)
        ),
            this.remove();
    }
}
customElements.define(
    "hdt-lazy-modal",
    class extends ti {
        constructor() {
            super(),
                f(ds, this),
                f(us, this, this.getAttribute("section-id")),
                this.addEventListener("dialog:doneClose", y(ds, this, cs).bind(this)),
                this.addEventListener("dialog:beforeOpen", () => {
                    const t = u("hdt-badge[update-hidden]", this);
                    t.length && t.forEach((t) => t.updateHiddenParent());
                });
        }
        async openDialog(t = !0, e) {
            const i = e ? e.getAttribute("handle") : this.getAttribute("handle");
            if (!i) return;
            document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 })),
                e?.setAttribute("aria-busy", "true");
            const s = await (await I(`${window.Shopify.routes.root}products/${i}?section_id=${w(us, this)}`)).text();
            document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 })),
                e?.setAttribute("aria-busy", "false");
            const n = new DOMParser().parseFromString(s, "text/html"),
                a = document
                    .createRange()
                    .createContextualFragment(n.getElementById(`shopify-section-${w(us, this)}`).innerHTML);
            return (
                this.replaceChildren(...a.children),
                N(this),
                R(this),
                q(this),
                Shopify?.PaymentButton?.init(),
                document.dispatchEvent(new CustomEvent("currency:update")),
                super.openDialog(t)
            );
        }
        get controls() {
            return u(`[aria-controls="${this.id}"]`, this.getRootNode());
        }
    }
),
    customElements.define(
        "wrapp-hdt-open-modal-btn",
        class extends Qe {
            constructor() {
                super(), c(this.firstElementChild.getAttribute("aria-controls"))?.updateBtbsOpen(this);
            }
            connectedCallback() {
                super.connectedCallback(),
                    d("hdt-tmp-quick")?.dispatchEvent(new CustomEvent("theme:update:id", { bubbles: !1 }));
            }
        }
    ),
    customElements.define("hdt-tmp-quick", ps);
var ms,
    bs,
    gs = new WeakMap();
class vs extends HTMLElement {
    constructor() {
        super(), f(ms, this), f(gs, this, d("form", this)), w(gs, this).addEventListener("submit", y(ms, this, bs));
    }
    connectedCallback() {
        (this.hideErrors = "true" === this.dataset.hideErrors), (w(gs, this).id.disabled = !1);
    }
}
(ms = new WeakSet()),
    (bs = async function (t) {
        if ((t.preventDefault(), this.checkBreak)) return;
        if (!this.checkValidity()) return void this.reportValidity();
        const e = Array.from(this.elements).filter((t) => "submit" === t.type);
        e.forEach((t) => {
            t.setAttribute("disabled", "disabled"), t.setAttribute("aria-busy", "true");
        }),
            document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 }));
        let i = [];
        document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: !0, detail: { sections: i } }));
        const s = new FormData(this);
        s.set("sections", i.join(","));
        const n = await fetch(`${Shopify.routes.root}cart/add.js`, {
            body: s,
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        e.forEach((t) => {
            t.removeAttribute("disabled"), t.removeAttribute("aria-busy");
        });
        const a = await n.json();
        if ((document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 })), n.ok)) {
            const t = await Ka();
            (t.sections = a.sections),
                this.dispatchEvent(
                    new CustomEvent("variant:add", {
                        bubbles: !0,
                        detail: {
                            items: a.hasOwnProperty("items") ? a.items : [a],
                            actionAfterATC: s.get("action_added"),
                            cart: t,
                        },
                    })
                ),
                document.dispatchEvent(
                    new CustomEvent("cart:change", {
                        bubbles: !0,
                        detail: { baseEvent: "variant:add", actionAfterATC: s.get("action_added"), cart: t },
                    })
                );
        } else {
            if (this.hideErrors) return;
            this.dispatchEvent(
                new CustomEvent("cart:add:error", {
                    bubbles: !0,
                    detail: { isGiftCardRecipient: "true" === this.dataset.giftCardRecipient, error: a.description },
                })
            );
        }
    });
var fs,
    ws,
    ys = new WeakMap();
(fs = new WeakSet()),
    (ws = function (t) {
        "plus" == t.detail.action
            ? ((this.totalPrice = this.totalPrice + t.detail.remainPrice),
              (this.totalComparePrice = this.totalComparePrice + t.detail.remainComparePrice))
            : ((this.totalPrice = this.totalPrice - t.detail.remainPrice),
              (this.totalComparePrice = this.totalComparePrice - t.detail.remainComparePrice));
        const e = d("hdt-compare-at-price", w(ys, this));
        e &&
            (e.toggleAttribute("hidden", this.totalComparePrice <= this.totalPrice),
            (d(".hdt-money", e).outerHTML = `<span class="hdt-money">${k(this.totalComparePrice)}</span>`)),
            (d("hdt-price .hdt-money", w(ys, this)).outerHTML = `<span class="hdt-money">${k(this.totalPrice)}</span>`),
            document.dispatchEvent(new CustomEvent("currency:update"));
    });
var Es,
    Cs,
    ks,
    xs,
    As,
    Ss,
    Ls,
    _s,
    Ms,
    Ts,
    Ws,
    Ps,
    Is,
    $s,
    Os,
    Hs,
    Ns,
    Rs,
    qs,
    Ds,
    Fs,
    Bs,
    Vs,
    zs,
    Ys,
    js,
    Xs,
    Us = new WeakMap();
class Js extends HTMLElement {
    #t;
    constructor() {
        super(), f(Es, this), f(Us, this, u('[name^="items[]"]', this));
    }
    connectedCallback() {
        this.#t = new AbortController();
        const t = d('[name="items[][id]"]', this);
        (this.price = Number(t.dataset.price)),
            (this.comparePrice = Number(t.dataset.cpprice)),
            this.addEventListener("change", y(Es, this, Cs).bind(this), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get observes() {
        return (this._observes = this._observes || c(this.getAttribute("observes")));
    }
}
(Es = new WeakSet()),
    (Cs = function (t) {
        const e = t.target;
        if ("SELECT" == e.tagName) {
            const t = e.options[e.selectedIndex],
                a = this.price,
                r = this.comparePrice;
            (this.price = Number(t.dataset.price)), (this.comparePrice = Number(t.dataset.cpprice));
            var i = "plus",
                s = this.price - a,
                n = this.comparePrice - r;
            if (
                (d("[update-price] hdt-compare-at-price", this).toggleAttribute(
                    "hidden",
                    this.comparePrice <= this.price
                ),
                (d("[update-price] hdt-compare-at-price .hdt-money", this).outerHTML =
                    `<span class="hdt-money">${k(this.comparePrice)}</span>`),
                (d("[update-price] hdt-price .hdt-money", this).outerHTML =
                    `<span class="hdt-money">${k(this.price)}</span>`),
                (d("[update-qty]", this).value = t.dataset.qty),
                (d("[update-img]", this.observes || this).src = t.dataset.img),
                document.dispatchEvent(new CustomEvent("currency:update")),
                !this.classList.contains("is-checked"))
            )
                return;
        } else if ("INPUT" == e.tagName) {
            w(Us, this).forEach((t) => {
                t.toggleAttribute("disabled", !e.checked);
            }),
                this.classList.toggle("is-checked", e.checked);
            (i = e.checked ? "plus" : "minus"), (s = this.price), (n = this.comparePrice);
            this.observes?.classList.toggle("is-checked", e.checked);
        }
        this.dispatchEvent(
            new CustomEvent("update:bundle:total", {
                bubbles: !0,
                detail: { remainPrice: s, remainComparePrice: n, action: i },
            })
        );
    });
class Zs extends HTMLElement {
    #t;
    constructor() {
        super(), f(ks, this), f(As, this);
    }
    get form() {
        return document.forms[this.getAttribute("form")];
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            this.form?.addEventListener(ls, y(ks, this, xs).bind(this), { signal: this.#t.signal }),
            this.form?.addEventListener("cart:add:error", y(As, this, Ss).bind(this), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
(ks = new WeakSet()),
    (xs = function (t) {
        const e = t.detail.variant,
            i = d('button[type="submit"]', this);
        (i.disabled = !e || !e.available),
            (i.firstElementChild.textContent =
                themeHDN.extras[
                    e ? (e.variant_state.pre_order ? "preOrder" : e.available ? "addToCart" : "soldOut") : "unavailable"
                ]),
            (this.previousElementSibling.hidden = !0),
            d("hdt-price", this)?.removeAttribute("hidden");
    }),
    (As = new WeakSet()),
    (Ss = function (t) {
        t.detail.isGiftCardRecipient ||
            ((this.previousElementSibling.hidden = !1),
            (this.previousElementSibling.lastElementChild.textContent = t.detail.error),
            this.form?.addEventListener("variant:add", () => (this.previousElementSibling.hidden = !0), { once: !0 }));
    });
class Qs extends HTMLElement {
    #t;
    constructor() {
        super(),
            f(Ls, this),
            f(Ms, this),
            f(Ws, this),
            f(Is, this),
            f(Os, this),
            (this.recipientFieldsLiveRegion = d(`#Recipient-fields-live-region-${this.sectionId}`, this)),
            (this.checkboxInput = d(`#Recipient-checkbox-${this.sectionId}`, this)),
            (this.checkboxInput.disabled = !1),
            (this.hiddenControlField = d(`#Recipient-control-${this.sectionId}`, this)),
            (this.hiddenControlField.disabled = !0),
            (this.emailInput = d(`#Recipient-email-${this.sectionId}`, this)),
            (this.nameInput = d(`#Recipient-name-${this.sectionId}`, this)),
            (this.messageInput = d(`#Recipient-message-${this.sectionId}`, this)),
            (this.sendonInput = d(`#Recipient-send-on-${this.sectionId}`, this)),
            (this.offsetProperty = d(`#Recipient-timezone-offset-${this.sectionId}`)),
            this.offsetProperty && (this.offsetProperty.value = new Date().getTimezoneOffset().toString()),
            (this.errorMessageWrapper = d(".hdt-form__message-wrapper", this)),
            (this.errorMessageList = this.errorMessageWrapper?.querySelector("ul")),
            (this.errorMessage = this.errorMessageWrapper?.querySelector(".hdt-error-message")),
            (this.defaultErrorHeader = this.errorMessage?.innerText);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            this.checkboxInput.addEventListener("change", y(Ls, this, _s).bind(this), { signal: this.#t.signal }),
            this.form?.addEventListener("cart:add:error", y(Ms, this, Ts).bind(this), { signal: this.#t.signal }),
            this.form?.addEventListener("variant:add", y(Os, this, Hs).bind(this), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get form() {
        return document.forms[this.getAttribute("form")];
    }
    get sectionId() {
        return this.dataset.sectionId;
    }
    inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
    }
    disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
    }
    enableInputFields() {
        this.disableableFields().forEach((t) => (t.disabled = !1));
    }
    disableInputFields() {
        this.disableableFields().forEach((t) => (t.disabled = !0));
    }
}
(Ls = new WeakSet()),
    (_s = function () {
        this.checkboxInput.checked
            ? (this.enableInputFields(),
              (this.recipientFieldsLiveRegion.innerText = this.recipientFieldsLiveRegion.dataset.expanded))
            : (this.disableInputFields(),
              (this.recipientFieldsLiveRegion.innerText = this.recipientFieldsLiveRegion.dataset.collapsed));
    }),
    (Ms = new WeakSet()),
    (Ts = function (t) {
        t.detail.isGiftCardRecipient && (console.log(t.detail), y(Ws, this, Ps).call(this, t.detail.error));
    }),
    (Ws = new WeakSet()),
    (Ps = function (t) {
        if ((y(Os, this, Hs).call(this), (this.errorMessageWrapper.hidden = !1), "object" == typeof t))
            return (
                (this.errorMessage.innerText = this.defaultErrorHeader),
                Object.entries(t).forEach(([t, e]) => {
                    const i = `RecipientForm-${t}-error-${this.sectionId}`,
                        s = `#Recipient-${t}-${this.sectionId}`,
                        n = `${e.join(", ")}`,
                        a = this.querySelector(`#${i}`),
                        r = a?.querySelector(".hdt-error-message");
                    if (!r) return;
                    this.errorMessageList && this.errorMessageList.appendChild(y(Is, this, $s).call(this, s, n)),
                        (r.innerText = `${n}.`),
                        a.removeAttribute("hidden");
                    const o = this[`${t}Input`];
                    o && (o.setAttribute("aria-invalid", !0), o.setAttribute("aria-describedby", i));
                })
            );
        this.errorMessage.innerText = t;
    }),
    (Is = new WeakSet()),
    ($s = function (t, e) {
        const i = document.createElement("li"),
            s = document.createElement("a");
        return s.setAttribute("href", t), (s.innerText = e), i.appendChild(s), (i.className = "hdt-error-message"), i;
    }),
    (Os = new WeakSet()),
    (Hs = function () {
        (this.errorMessageWrapper.hidden = !0),
            this.errorMessageList && (this.errorMessageList.innerHTML = ""),
            this.querySelectorAll(".hdt-recipient-fields .hdt-form__message").forEach((t) => {
                t.setAttribute("hidden", "");
                const e = t.querySelector(".hdt-error-message");
                e && (e.innerText = "");
            }),
            [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((t) => {
                t.setAttribute("aria-invalid", !1), t.removeAttribute("aria-describedby");
            });
    }),
    customElements.define("wrapp-hdt-pr-frm", vs),
    customElements.define(
        "wrapp-hdt-pr-frm-bundle",
        class extends vs {
            constructor() {
                super(), f(fs, this);
            }
            connectedCallback() {
                f(ys, this, d("[update-total]", this)),
                    (this.totalPrice = Number(w(ys, this).dataset.price)),
                    (this.totalComparePrice = Number(w(ys, this).dataset.cpprice)),
                    this.addEventListener("update:bundle:total", y(fs, this, ws).bind(this));
            }
            disconnectedCallback() {
                this.removeEventListener("update:bundle:total", y(fs, this, ws).bind(this));
            }
        }
    ),
    customElements.define("hdt-bundle-product", Js),
    customElements.define("hdt-buy-buttons", Zs),
    customElements.define("hdt-recipient-form", Qs);
class Gs extends HTMLElement {
    #t;
    constructor() {
        super(), f(Ns, this), f(Ds, this), f(Bs, this), f(zs, this);
    }
    async connectedCallback() {
        if (((this.#t = new AbortController()), !this.hasAttribute("handle"))) return;
        var t = (await await O.load(this.getAttribute("handle"))).variants;
        this.hideSoldOutVariants && (t = t.filter((t) => t.available));
        const e = new DOMParser().parseFromString(this.nextElementSibling.textContent, "text/html");
        e &&
            u("select > option", e).forEach((e, i) => {
                const s = e.dataset;
                let n = t[i];
                (n = Object.assign(n, {
                    inventory_policy: s.inventorypolicy || null,
                    inventory_quantity: parseInt(s.inventoryquantity),
                    mdid: s.mdid || null,
                })),
                    (n.variant_state = {
                        sold_out: !n.available,
                        on_sale: n.compare_at_price > n.price,
                        pre_order: "shopify" == n.inventory_management && n.inventory_quantity <= 0 && n.available,
                    }),
                    n.quantity_rule || (n.quantity_rule = { min: 1, max: null, increment: 1, max4: !0 });
                const { inventory_quantity: a, inventory_management: r, inventory_policy: o } = n;
                !n.quantity_rule.max &&
                    a > 0 &&
                    null != r &&
                    "continue" != o &&
                    ((n.quantity_rule.max = a), (n.quantity_rule.max4 = !0));
            }),
            f(qs, this, t),
            (t = null),
            (this.masterInput = this.idELForm),
            y(zs, this, Ys).call(this, !0),
            this.masterInput &&
                ((this.masterInput.disabled = !1),
                f(js, this),
                this.addEventListener("change", y(Ns, this, Rs).bind(this), { signal: this.#t.signal }),
                this.masterInput.addEventListener("change", y(js, this, Xs).bind(this), { signal: this.#t.signal }),
                u('fieldset[type^="dropdown"]', this).forEach((t) => {
                    d("hdt-popover", t).addEventListener(
                        "richlist:change",
                        (e) => {
                            const i = d(`input[type="hidden"][name="option${parseInt(t.dataset.index) + 1}"]`, t);
                            i.value != e.detail.value &&
                                ((i.value = e.detail.value), i.dispatchEvent(new Event("change", { bubbles: !0 })));
                        },
                        { signal: this.#t.signal }
                    );
                }));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get idELForm() {
        const t = this.getAttribute("form");
        if (!document.forms[t]) {
            const e = `<form id="${t}" action="${Shopify.routes.root}cart/add.js" method="POST" hidden><input type="hidden" name="id" value="${this.getAttribute("selected-variant")}"></form>`;
            this.insertAdjacentHTML("afterend", e);
        }
        return document.forms[t].id;
    }
    get hideSoldOutVariants() {
        return this.hasAttribute("hide-sold-out-variants");
    }
    get updateUrl() {
        return this.getAttribute("update-url");
    }
    get updateStatus() {
        return this.hasAttribute("update-status");
    }
    get productMedia() {
        return (this._productMedia = this._productMedia || d(`hdt-product-media[form="${this.getAttribute("form")}"]`));
    }
    getvariantObjById(t) {
        return w(qs, this).find((e) => e.id == t);
    }
    updateOptions() {
        const t = u("fieldset", this);
        this.options = t
            .map((t) => u("input", t).find((t) => t.checked || "hidden" == t.type)?.value)
            .filter(function (t) {
                return void 0 !== t && "" !== t;
            });
    }
    updateMasterId() {
        this.currentVariant = w(qs, this).find((t) => !t.options.map((t, e) => this.options[e] === t).includes(!1));
    }
    selectVariantByID(t, e = !0) {
        this.hasAttribute("no-pick") || this.selectVariantByVariantObj(this.getvariantObjById(t), e);
    }
    selectVariantByVariantObj(t, e = !0, i = !1) {
        "object" == typeof t &&
            w(qs, this).includes(t) &&
            ((this.options = t.options), (this.currentVariant = t), this.selectVariant(!1, e, i));
    }
    selectVariant(t = !1, e = !0, i = !1) {
        (this.oldVariant && this.oldVariant.id === this.currentVariant.id && !i) ||
            ((this.oldVariant = this.currentVariant),
            (this.masterInput.value = this.currentVariant.id),
            this.masterInput.dispatchEvent(
                new CustomEvent("change", { bubbles: !0, detail: { hasVariant: !0, untriggerChangeEvent: t } })
            ),
            y(Bs, this, Vs).call(this),
            y(zs, this, Ys).call(this),
            this.masterInput.form.dispatchEvent(
                new CustomEvent(ls, { bubbles: !0, detail: { variant: this.currentVariant, jumpMedia: e } })
            ));
    }
}
function Ks(t, e, i) {
    return i.indexOf(t) === e;
}
(qs = new WeakMap()),
    (Ns = new WeakSet()),
    (Rs = function (t) {
        if (!t.target.hasAttribute("is-value")) return;
        const e = t.target.closest("fieldset");
        // if (e.classList.contains("has_color")) {
        //     document
        //         .querySelectorAll(".get_wrapper .express-icon, .express-icon-color")
        //         .forEach((e) => (e.style.display = "none"));
        //     const t = e.target?.defaultValue ? e.target?.defaultValue : "";
        //     document.querySelectorAll(".express-select option").forEach((e) => {
        //         const o = e.getAttribute("data-title"),
        //             n = "true" === e.value,
        //             c = e.getAttribute("data-option")?.toLowerCase();
        //         if (o === t && n) {
        //             const t = document.querySelector(`.get_input.get_${c}`);
        //             t?.closest(".get_wrapper")?.querySelector(".express-icon")?.style.setProperty("display", "block"),
        //                 t
        //                     ?.closest(".hdt-variant-picker")
        //                     ?.querySelector(".express-icon-color")
        //                     ?.style.setProperty("display", "block");
        //         }
        //     });
        // }
        if (
            ((this.clickedCurrentIndex = parseInt(e.dataset.index)),
            (this.clickedCurrentValue = t.target.value),
            this.updateOptions(),
            this.options.length < parseInt(this.dataset.size))
        ) {
            d("[update-value]", e).textContent = this.clickedCurrentValue;
            const t = ["nanthan94", "nanthan94", "nanthan94"];
            return (
                (t[this.clickedCurrentIndex] = this.clickedCurrentValue),
                void this.productMedia?.dispatchEvent(new CustomEvent("update:value", { detail: { options: t } }))
            );
        }
        this.removeAttribute("no-pick"),
            this.updateMasterId(),
            this.currentVariant || y(Ds, this, Fs).call(this),
            this.selectVariant(!0);
    }),
    (js = new WeakSet()),
    (Xs = function (t) {
        if (
            ((t.detail && t.detail.hasVariant) || (this.currentVariant = this.getvariantObjById(t.target.value)),
            !this.currentVariant)
        )
            return;
        let e = [];
        u("fieldset[data-index]", this).forEach((i, s) => {
            let n = this.currentVariant.options[s],
                a = i.getAttribute("type"),
                r = d("[update-value]", i),
                o = d(`input[type="radio"][value="${CSS.escape(n)}"], input[type="hidden"][name="option${s + 1}"]`, i),
                h = !1;
            if (a.startsWith("dropdown")) {
                (h = o.value !== n), (o.value = n);
                const t = d("hdt-richlist", i);
                t && (t.selected = n);
            } else (h = !o.checked && o.value === n), (o.checked = !0);
            t.detail && t.detail.untriggerChangeEvent && (h = !1), r && (r.textContent = n), h && e.push(o);
        }),
            e.forEach((t) => t.dispatchEvent(new CustomEvent("change", { bubbles: !0 }))),
            (e = []);
    }),
    (Ds = new WeakSet()),
    (Fs = function () {
        let t,
            e = parseInt(this.dataset.size),
            i = !this.hideSoldOutVariants;
        (t =
            1 == e
                ? w(qs, this).filter((t) => t.available)
                : 3 == e
                  ? w(qs, this).filter(
                        (t) => t.option1 == this.options[0] && t.option2 == this.options[1] && (i || t.available)
                    )
                  : w(qs, this).filter((t) => t.option1 == this.options[0] && (i || t.available))),
            t[0] ||
                (t = w(qs, this).filter(
                    (t) => t.options[this.clickedCurrentIndex] == this.clickedCurrentValue && (i || t.available)
                )),
            (this.currentVariant = t[0]);
    }),
    (Bs = new WeakSet()),
    (Vs = function () {
        if (!this.updateStatus) return;
        const t = w(qs, this).filter((t) => t.option1 == this.currentVariant.option1),
            e = w(qs, this).filter(
                (t) => t.option1 == this.currentVariant.option1 && t.option2 == this.currentVariant.option2
            ),
            i = w(qs, this)
                .map((t) => t.option1)
                .filter(Ks),
            s = t.map((t) => t.option2).filter(Ks),
            n = e.map((t) => t.option3).filter(Ks),
            a = w(qs, this)
                .filter((t) => t.available)
                .map((t) => t.option1)
                .filter(Ks),
            r = t
                .filter((t) => t.available)
                .map((t) => t.option2)
                .filter(Ks),
            o = e
                .filter((t) => t.available)
                .map((t) => t.option3)
                .filter(Ks);
        u("fieldset[data-index]", this).forEach((t, e) => {
            let h = ++e;
            u('[type="radio"], hdt-richlist > button', t).forEach((t) => {
                let e = !0,
                    l = !0;
                switch (h) {
                    case 1:
                        i.includes(t.value) && (e = !1), a.includes(t.value) && (l = !1);
                        break;
                    case 2:
                        s.includes(t.value) && (e = !1), r.includes(t.value) && (l = !1);
                        break;
                    default:
                        n.includes(t.value) && (e = !1), o.includes(t.value) && (l = !1);
                }
                t.classList.toggle("is-disabled", l), t.classList.toggle("is-unavailable", e);
            });
        });
    }),
    (zs = new WeakSet()),
    (Ys = function (t) {
        if (!this.updateUrl || !history.replaceState) return;
        const e = new URL(window.location.href),
            i = t ? this.updateUrl : this.currentVariant.id;
        i ? e.searchParams.set("variant", i) : e.searchParams.delete("variant"),
            window.history.replaceState({ path: e.toString() }, "", e.toString());
    });
class tn extends HTMLElement {
    constructor() {
        super(), (this._onVariantChanged = this.onVariantChanged.bind(this));
    }
    get form() {
        return (this._form = this._form || document.forms[this.getAttribute("form")]);
    }
    connectedCallback() {
        this.form?.addEventListener(ls, this._onVariantChanged);
    }
    disconnectedCallback() {
        this.form?.removeEventListener(ls, this._onVariantChanged);
    }
    onVariantChanged() {}
}
class en extends tn {
    onVariantChanged(t) {
        const e = t.detail.variant;
        (d(".hdt-money", this).outerHTML = `<span class="hdt-money">${k(e.price, hs)}</span>`),
            this.classList.toggle("hdt-price-on-sale", e.variant_state.on_sale),
            document.dispatchEvent(new CustomEvent("currency:update")),
            this.dispatchEvent(new CustomEvent("price:update"));

            let form = t.target;
            if(form){
				let this_section_id = form.dataset.sectionId;
				let this_product_url = form.dataset.productUrl;
				let final_url = `${this_product_url}?variant=${t.detail.variant.id}&section_id=${this_section_id}`;
				let parent_element = form.closest('.hdt-main-product-quick-add, .hdt-main-product-wrap');
				fetch(final_url)
					.then(response => response.text()) 
					.then(html => {
							const parser = new DOMParser();
							const doc = parser.parseFromString(html, 'text/html');
							const content = doc.querySelector('hdt-variant-picker');

							let source_icons = content.querySelectorAll('hdt-express-icon');
							let destination_icons = parent_element.querySelectorAll('hdt-express-icon');

							source_icons.forEach((source_icon) => {
								destination_icons.forEach((destination_icon) => {
									if(source_icon.id == destination_icon.id) {
										destination_icon.style.display = source_icon.style.display;
										return;
									}
								});
							});
							// Inject it into your current page
							//document.querySelector('#target').innerHTML = content ? content.innerHTML : html;
					})
					.catch(error => console.error('Error fetching HTML:', error));
            }
    }
}
var sn,
    nn,
    an,
    rn,
    on,
    hn,
    ln = new WeakMap(),
    dn = new WeakMap(),
    cn = new WeakMap();
(sn = new WeakSet()),
    (nn = function (t) {
        let e = "";
        (e = t.available
            ? t.inventory_quantity > 0
                ? t.inventory_quantity <= w(dn, this) && t.requires_shipping
                    ? w(ln, this)
                        ? "low-stock-count"
                        : "low-stock"
                    : w(ln, this)
                      ? "in-stock-count"
                      : "in-stock"
                : "shopify" == t.inventory_management
                  ? "pre-order-stock"
                  : "in-stock"
            : "out-of-stock"),
            "low-stock" == e || "in-stock" == e || "low-stock-count" == e || "in-stock-count" == e
                ? (u("[data-quantity]", this).forEach((e) => (e.textContent = t.inventory_quantity)),
                  this.progressBar &&
                      ((this.progressBar.hidden = !1),
                      (this.progressBar.valueNow =
                          t.inventory_quantity > 0
                              ? t.inventory_quantity
                              : this.progressBar.getAttribute("aria-valuemax"))))
                : this.progressBar?.setAttribute("hidden", ""),
            d(".hdt-stock-status:not([hidden])", this)?.setAttribute("hidden", ""),
            d(`.hdt-stock-status[${e || "nt94"}]`, this)?.removeAttribute("hidden");
    });
(an = new WeakSet()),
    (rn = async function (t) {
        if (t) {
            const e = document.createElement("div");
            this.setAttribute("loading", ""),
                (e.innerHTML = await (
                    await fetch(`${Shopify.routes.root}variants/${t.id}?section_id=pickup-availability`)
                ).text()),
                this.replaceChildren(...e.querySelector("hdt-pickup-availability").childNodes),
                this.removeAttribute("loading", "");
        } else this.innerHTML = "";
    });
(on = new WeakSet()),
    (hn = function (t, e) {
        return M(
            Object.assign(t, {
                onload: !0,
                attrs: { class: e.className, sizes: e.sizes, "data-widths": e.getAttribute("data-widths") || "[]" },
            })
        );
    });
var un,
    pn,
    mn,
    bn,
    gn,
    vn,
    fn,
    wn,
    yn,
    En,
    Cn,
    kn,
    xn = new WeakMap(),
    An = new WeakMap(),
    Sn = new WeakMap(),
    Ln = new WeakMap(),
    _n = new WeakMap(),
    Mn = !0;
(un = new WeakSet()),
    (pn = function (t) {
        if (this.variantPicker?.hasAttribute("no-pick"))
            return (Mn = !1), void document.body.style.setProperty("--sticky-atc-height", "0px");
        document.body.style.removeProperty("--sticky-atc-height");
        const e = t.find((t) => t.target === w(An, this)),
            i = !!w(Sn, this) && t.find((t) => t.target === w(Sn, this));
        e && f(_n, this, !e.isIntersecting && e.boundingClientRect.bottom < 0, !0),
            i && w(Sn, this) && f(_n, this, !i.isIntersecting, !0),
            document.body.classList.toggle("sticky-shown", w(_n, this)),
            Mn &&
                !w(_n, this) &&
                setTimeout(() => {
                    f(_n, this, window.innerHeight + Math.round(window.scrollY) >= document.body.offsetHeight, !0),
                        document.body.classList.toggle("sticky-shown", w(_n, this)),
                        (Mn = !1);
                }, 100);
    });
class Tn extends HTMLElement {
    constructor() {
        super(),
            f(mn, this),
            this.addEventListener("click", y(mn, this, bn).bind(this, this.input)),
            (this.actionCopy = this.input ? "value" : "textContent"),
            this.input &&
                this.hasAttribute("get-document") &&
                this.closest("hdt-popover")?.addEventListener("dialog:beforeOpen", (t) => {
                    this.input[this.actionCopy] = this.textCopy;
                });
    }
    get input() {
        return c(this.getAttribute("text-id"));
    }
    get textCopy() {
        return this.hasAttribute("get-document") ? document.location.href : this.getAttribute("data-text") || "";
    }
}
(mn = new WeakSet()),
    (bn = async function (t) {
        if (
            navigator.clipboard &&
            (await navigator.clipboard.writeText(this.textCopy), this.hasAttribute("data-success-message"))
        ) {
            const e = (t = t || this)[this.actionCopy];
            (t[this.actionCopy] = this.getAttribute("data-success-message")),
                setTimeout(() => {
                    t[this.actionCopy] = e;
                }, 1500);
        }
    });
class Wn extends HTMLElement {
    constructor() {
        super(),
            f(gn, this),
            navigator.share &&
                !window.matchMedia("screen and (pointer: fine)").matches &&
                ((this.hidden = !1), this.addEventListener("click", y(gn, this, vn)));
    }
}
(gn = new WeakSet()),
    (vn = function () {
        navigator.share({
            title: this.getAttribute("share-title") || document.title,
            url: this.getAttribute("share-link") || document.location.href,
        });
    });
class Pn extends HTMLElement {
    constructor() {
        super(), f(fn, this);
    }
    connectedCallback() {
        this.firstElementChild && document.addEventListener(ls, y(fn, this, wn).bind(this));
    }
}
(fn = new WeakSet()),
    (wn = function (t) {
        const e = t.detail.variant;
        u("[variant-id]:not([hidden])", this).forEach((t) => (t.hidden = !0)),
            e && e.id && d(`[variant-id="${e.id}"]`, this)?.removeAttribute("hidden");
    }),
    customElements.define("hdt-variant-picker", Gs),
    customElements.define("hdt-price", en),
    customElements.define(
        "hdt-compare-at-price",
        class extends en {
            onVariantChanged(t) {
                const e = t.detail.variant;
                (this.hidden = !(e.compare_at_price > e.price)),
                    this.hidden ||
                        ((d(".hdt-money", this).outerHTML =
                            `<span class="hdt-money">${k(e.compare_at_price, hs)}</span>`),
                        document.dispatchEvent(new CustomEvent("currency:update")),
                        this.dispatchEvent(new CustomEvent("price:update")));
            }
        }
    ),
    customElements.define(
        "hdt-unit-price",
        class extends en {
            onVariantChanged(t) {
                const e = t.detail.variant;
                (this.hidden = !e.unit_price),
                    this.hidden ||
                        ((d(".hdt-money", this).outerHTML = `<span class="hdt-money">${k(e.unit_price, hs)}</span>`),
                        document.dispatchEvent(new CustomEvent("currency:update")),
                        this.dispatchEvent(new CustomEvent("price:update")));
            }
        }
    ),
    customElements.define(
        "hdt-qty-price",
        class extends en {
            constructor() {
                super(), (this._onVariantChanged = this.onVariantChanged.bind(this));
            }
            get qty() {
                return this._qty || d(`[name="quantity"][form="${this.getAttribute("form")}"]`);
            }
            onVariantChanged(t) {
                this.setAttribute("variant-price", t.detail.variant.price), (this.hidden = !1), this.updatPrice();
            }
            connectedCallback() {
                super.connectedCallback(),
                    this.qty?.addEventListener("change", this.updatPrice.bind(this)),
                    this.qty?.addEventListener("input", A(this.updatPrice.bind(this), 300));
            }
            updatPrice() {
                const t = parseFloat(this.getAttribute("variant-price"));
                (d(".hdt-money", this).outerHTML =
                    `<span class="hdt-money">${k(t * (this.qty ? this.qty.value : 1), hs)}</span>`),
                    document.dispatchEvent(new CustomEvent("currency:update"));
            }
        }
    ),
    customElements.define(
        "hdt-badge",
        class extends tn {
            constructor() {
                super(), this.updateHiddenParent(), this.parentElement && this.parentElement.classList.add("js-intent");
            }
            get is() {
                return this.getAttribute("is");
            }
            get type() {
                return this.getAttribute("type");
            }
            updateHiddenParent() {
                this.parentElement &&
                    this.hasAttribute("update-hidden") &&
                    (this.parentElement.removeAttribute("hidden"),
                    (this.parentElement.hidden = !this.parentElement.clientHeight));
            }
            onVariantChanged(t) {
                const e = t.detail.variant;
                (this.hidden = "available" != this.is ? !e.variant_state[this.is] : !e.available),
                    this.updateHiddenParent();
                const i = d("[percent]", this);
                if (!this.hidden && "percentage" === this.type && i) {
                    const t = (100 * (e.compare_at_price - e.price)) / e.compare_at_price;
                    t != i.textContent && (i.textContent = Math.max(1, Math.round(t)));
                }
            }
        }
    ),
    customElements.define(
        "hdt-variant-inventory",
        class extends tn {
            constructor() {
                super(),
                    f(sn, this),
                    f(ln, this, this.hasAttribute("show-inventory-quantity")),
                    f(dn, this, parseInt(this.getAttribute("inventory-threshold"))),
                    f(cn, this, d(".hdt-progress-bar", this));
            }
            get progressBar() {
                return w(cn, this);
            }
            onVariantChanged(t) {
                y(sn, this, nn).call(this, t.detail.variant);
            }
        }
    ),
    customElements.define(
        "hdt-variant-live",
        class extends tn {
            get is() {
                return this.getAttribute("is");
            }
            onVariantChanged(t) {
                const e = t.detail.variant;
                if (((this.hidden = !e || "" === e[this.is]), !this.hidden)) {
                    (d("[update-value]", this) || this).innerText = e[this.is];
                }
            }
        }
    ),
    customElements.define(
        "hdt-pickup-availability",
        class extends tn {
            constructor() {
                super(), f(an, this);
            }
            onVariantChanged(t) {
                y(an, this, rn).call(this, t.detail.variant);
            }
        }
    ),
    customElements.define(
        "hdt-variant-preview-img",
        class extends tn {
            constructor() {
                super(), f(on, this);
            }
            onVariantChanged(t) {
                const e = t.detail.variant,
                    i = d("img", this);
                e && e.featured_image && i && i.replaceWith(y(on, this, hn).call(this, e.featured_image, i));
            }
        }
    ),
    customElements.define(
        "hdt-payment-terms",
        class extends tn {
            onVariantChanged(t) {
                if (t.detail.variant) {
                    const e = d('[name="id"]', this);
                    (e.value = t.detail.variant.id), e.dispatchEvent(new Event("change", { bubbles: !0 }));
                }
            }
        }
    ),
    customElements.define(
        "hdt-back-instock",
        class extends tn {
            connectedCallback() {
                this.hasAttribute("is-pr-default") ||
                    ((this.select = d("[back-instock-select]", this)),
                    (this.originalText = d("[back-instock-text]", this).textContent),
                    (this.elReplace = d('[name="contact[product]"]', this)),
                    this.select.addEventListener("change", (t) => {
                        this.elReplace.textContent = this.originalText
                            .replace("nt94_name", this.select.selectedOptions[0].textContent)
                            .replace("nt94_vid", this.select.value);
                    }),
                    super.connectedCallback());
            }
            onVariantChanged(t) {
                const e = t.detail.variant;
                this.hasAttribute("toogle-hidden") && (this.hidden = e && e.available),
                    e &&
                        !e.available &&
                        this.select.value != e.id &&
                        ((this.select.value = e.id), this.select.dispatchEvent(new Event("change", { bubbles: !1 })));
            }
        }
    ),
    customElements.define(
        "hdt-incoming-mess",
        class extends tn {
            connectedCallback() {
                this.hasAttribute("is-pr-default") || super.connectedCallback();
            }
            onVariantChanged(t) {
                const e = t.detail.variant,
                    i = JSON.parse(this.dataset.obj)[e.id];
                (this.hidden = !e || !i),
                    i &&
                        ((d(
                            "[data-incoming-date]",
                            e.available ? this.firstElementChild : this.lastElementChild
                        ).textContent = i),
                        (this.firstElementChild.hidden = !e.available || !e.requires_shipping),
                        (this.lastElementChild.hidden = !this.firstElementChild.hidden));
            }
        }
    ),
    customElements.define(
        "hdt-sticky-btn-atc",
        class extends tn {
            #e;
            constructor() {
                super(...arguments),
                    f(un, this),
                    f(_n, this, !1),
                    f(Ln, this, new IntersectionObserver(y(un, this, pn).bind(this)));
            }
            connectedCallback() {
                f(An, this, document.forms[this.getAttribute("form")]),
                    w(An, this) &&
                        (w(Ln, this).observe(w(An, this)),
                        f(Sn, this, d("hdt-quick-order-list")),
                        w(Sn, this) && w(Ln, this).observe(w(Sn, this))),
                    this.hasAttribute("is-pr-default") ||
                        (f(xn, this, d("[tag-select]", this)),
                        (this.#e = w(xn, this).value),
                        super.connectedCallback(),
                        w(xn, this).addEventListener("change", (t) => {
                            this.variantPicker?.selectVariantByID(
                                t.target.value,
                                d(".hdt-product-media__main hdt-slider")?.isActive
                            );
                        }));
            }
            get variantPicker() {
                return (this._variantPicker =
                    this._variantPicker || d(`hdt-variant-picker[form="${this.getAttribute("form")}"]`));
            }
            onVariantChanged(t) {
                const e = t.detail.variant;
                if (e && this.#e != e.id) {
                    (w(xn, this).value = e.id), (this.#e = w(xn, this).value);
                    const t = d("[data-v-img]", this),
                        i = e.featured_image;
                    if (t && i) {
                        const e = M({
                            src: i.src,
                            width: t.getAttribute("width"),
                            height: t.getAttribute("height"),
                            alt: t.alt,
                            onload: !0,
                            attrs: {
                                class: t.className,
                                sizes: t.sizes,
                                "data-widths": t.getAttribute("data-widths") || "[]",
                                "data-v-img": "",
                            },
                        });
                        t.replaceWith(e);
                    }
                    d("wrapp-hdt-pr-frm > form", this).dispatchEvent(
                        new CustomEvent(ls, { bubbles: !1, detail: { variant: e, jumpMedia: !1 } })
                    ),
                        (d('[name="add"]', this).disabled = !e || !e.available),
                        (d('[name="add"]', this).firstElementChild.textContent =
                            themeHDN.extras[
                                e
                                    ? e.variant_state.pre_order
                                        ? "preOrder"
                                        : e.available
                                          ? "addToCart"
                                          : "soldOut"
                                    : "unavailable"
                            ]);
                }
            }
        }
    ),
    customElements.define("wrapp-hdt-copy-btn", Tn),
    customElements.define("wrapp-hdt-share-btn", Wn),
    customElements.define("hdt-varaint-toogle-info", Pn);
class In extends HTMLElement {
    constructor() {
        super(),
            f(yn, this),
            f(Cn, this),
            document.addEventListener("theme:loading:doing", y(yn, this, En).bind(this)),
            document.addEventListener("theme:loading:done", y(Cn, this, kn).bind(this));
    }
}
(yn = new WeakSet()),
    (En = function () {
        mt(this, { opacity: [0, 1], transform: ["scaleX(0)", "scaleX(0.8)"] }, { duration: 0.5 });
    }),
    (Cn = new WeakSet()),
    (kn = async function () {
        await mt(this, { transform: [null, "scaleX(1)"] }, { duration: 0.25 }).finished,
            mt(this, { opacity: 0 }, { duration: 0.25 });
    }),
    customElements.define("hdt-loading-bar", In);
class $n extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        _("motion") && this.enabledReveal && u(this.selector, this).length > 0 && vt(this, this.reveal.bind(this));
    }
    get selector() {
        const t = this.getAttribute("selector") || ".hdt-card-product";
        return (this.prependEl || "") + t + (this.appendEl || "").replaceAll(/nathan/g, t);
    }
    get enabledReveal() {
        return "true" === this.getAttribute("reveal-on-scroll");
    }
    reveal() {
        mt(
            u(this.selector, this),
            { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] },
            { duration: 0.25, easing: "ease", delay: ft(0.05, { start: 0.3, easing: "ease" }) }
        );
    }
}
customElements.define("hdt-reval-items", $n);
var On,
    Hn,
    Nn,
    Rn,
    qn = new WeakMap();
const Dn = "shopify-section";
class Fn extends HTMLElement {
    #t;
    constructor() {
        super(), f(On, this), f(Nn, this), f(qn, this, d("a", this));
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            (this.abortController2 = null),
            w(qn, this).addEventListener("click", y(On, this, Hn).bind(this), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get idcontrol() {
        return "#" + w(qn, this).getAttribute("append");
    }
}
(On = new WeakSet()),
    (Hn = function (t) {
        t.preventDefault();
        const e = new URL(w(qn, this).href);
        e.searchParams.set("section_id", w(qn, this).getAttribute("section-id")),
            y(Nn, this, Rn).call(this, { detail: { url: e, id: this.idcontrol } });
    }),
    (Nn = new WeakSet()),
    (Rn = async function (t) {
        this.abortController2 && this.abortController2.abort(), (this.abortController2 = new AbortController());
        const e = t.detail.url,
            i = e.searchParams.get("section_id"),
            s = e.searchParams.get("page"),
            n = this.getAttribute("tab-id") || `${Dn}-${i}`,
            a = document.getElementById(n) || document.getElementById(`${Dn}-${i}`);
        new URL(e).searchParams.delete("section_id");
        const r = d(t.detail.id, a),
            o = d("[loadmore-btn-wrapp]", a);
        try {
            o.setAttribute("loading", "");
            const i = new DOMParser().parseFromString(
                    await (await fetch(e.toString(), { signal: this.abortController2.signal }).then((t) => t)).text(),
                    "text/html"
                ),
                a = d(`.${Dn} ${t.detail.id}`, i);
            r.lastElementChild.classList.add(`point-effect-${s}`),
                r.append(...document.importNode(a, !0).childNodes),
                r.dispatchEvent(new CustomEvent("products:update", { bubbles: !0 })),
                _("motion") && ((r.prependEl = `.point-effect-${s} ~ `), r.reveal());
            const h = d("[loadmore-btn-wrapp]", d("#" + n, i));
            h
                ? (o.replaceChildren(...document.importNode(h, !0).childNodes), o.removeAttribute("loading"))
                : o.remove();
        } catch (t) {}
    }),
    customElements.define("wrapp-hdt-lm-url", Fn);
var Bn,
    Vn,
    zn,
    Yn,
    jn,
    Xn,
    Un,
    Jn,
    Zn,
    Qn,
    Gn,
    Kn,
    ta,
    ea,
    ia,
    sa,
    na = new WeakMap();
class aa extends HTMLElement {
    #t;
    constructor() {
        super(...arguments),
            f(Vn, this, d("input", this)),
            f(zn, this),
            f(jn, this),
            f(Un, this),
            f(Zn, this),
            f(na, this, d(`hdt-variant-picker[form="${this.getAttribute("form")}"]`));
    }
    get input() {
        return w(Vn, this);
    }
    get quantityForm() {
        return c(`Quantity-Form-${this.getAttribute("section-id")}`);
    }
    async connectedCallback() {
        if (((this.#t = new AbortController()), this.input)) {
            if (
                (f(
                    Bn,
                    this,
                    document.forms[
                        (this.getAttribute("form") || this.input.getAttribute("form") || "").replace("id:", "")
                    ]
                ),
                this.input.addEventListener("change", this.onInputChange.bind(this), { signal: this.#t.signal }),
                u("button", this).forEach((t) =>
                    t.addEventListener("click", this.onButtonClick.bind(this), { signal: this.#t.signal })
                ),
                (this.buttonMinus = d(".hdt-quantity__button[name='minus']", this)),
                (this.buttonPlus = d(".hdt-quantity__button[name='plus']", this)),
                this.validateQtyRules(),
                this.quantityForm && this.hasAttribute("handle"))
            ) {
                if (w(na, this)) await O.load(this.getAttribute("handle")), (this.variants = w(qs, w(na, this)));
                else {
                    this.variants = (await await O.load(this.getAttribute("handle"))).variants;
                    const t = this.variants[0];
                    t.quantity_rule || (t.quantity_rule = { min: 1, max: null, increment: 1, max4: !0 }),
                        t.quantity_rule.max ||
                            ((t.quantity_rule.max = this.input.dataset.max), (t.quantity_rule.max4 = !0)),
                        (this.variants[0] = t);
                }
                y(Zn, this, Qn).call(this),
                    w(Bn, this)?.addEventListener(ls, y(zn, this, Yn).bind(this), { signal: this.#t.signal }),
                    document.addEventListener("cart:change", y(jn, this, Xn).bind(this), { signal: this.#t.signal });
            }
            this.debouncedOnChange = A(() => {
                this.input.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { target: this.input } }));
            }, 300);
        }
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    onInputChange() {
        this.validateQtyRules();
    }
    onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value;
        "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(),
            e !== this.input.value && this.debouncedOnChange();
    }
    validateQtyRules() {
        const t = parseInt(this.input.value),
            e = this.input.max || 9999,
            i = parseInt("null" != String(e) ? e : 9999);
        (this.input.value = Math.min(t, i)),
            this.hasAttribute("form") &&
                w(Bn, this)?.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { target: this.input } })),
            this.input.min && this.buttonMinus.classList.toggle("disabled", t <= parseInt(this.input.min)),
            this.buttonPlus.classList.toggle("disabled", t >= parseInt(i));
    }
}
(Bn = new WeakMap()),
    (Vn = new WeakMap()),
    (zn = new WeakSet()),
    (Yn = function (t) {
        const e = t.detail.variant;
        this.setAttribute("variant-id", e ? e.id : ""), e && y(Un, this, Jn).call(this, e);
    }),
    (jn = new WeakSet()),
    (Xn = async function (t) {
        if (!this.variants) return;
        d(".hdt-quantity__rules-cart", this.quantityForm).hidden = !0;
        const e = this.variants.find((t) => this.getAttribute("variant-id") == t.id);
        if (!e) return;
        const i = t.detail.cart || (await tr);
        i.items.concat(i.items_added || [], i.items_removed || []).find((t) => e.id == t.variant_id) &&
            y(Un, this, Jn).call(this, e, i);
    }),
    (Zn = new WeakSet()),
    (Qn = function () {
        const t = {
            cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            step: this.input.step ? parseInt(this.input.step) : 1,
        };
        let e = t.min;
        const i = null == t.max ? t.max : t.max - t.cartQuantity;
        null != i && (e = Math.min(e, i)),
            t.cartQuantity >= t.min && (e = Math.min(e, t.step)),
            (this.input.min = e),
            (this.input.max = i),
            (this.input.value = e),
            this.input.dispatchEvent(new Event("change"));
    }),
    (Un = new WeakSet()),
    (Jn = async function (t, e = null) {
        const i = (e = e || (await tr)).items.find((e) => e.id === t.id);
        (d(".hdt-quantity__rules-cart", this.quantityForm).hidden = !i),
            i && (d(".hdt-quantity-cart", this.quantityForm).textContent = i.quantity),
            t.quantity_rule || (t.quantity_rule = { min: 1, max: null, increment: 1, max4: !0 });
        const s = t.quantity_rule,
            { increment: n, min: a, max: r } = themeHDN.extras.quantity;
        d(".hdt-quantity__rules", this.quantityForm).innerHTML =
            `${s.increment > 1 ? `<span class="hdt-divider">${n.replace("1904", s.increment)}</span>` : ""}${s.min > 1 ? `<span class="hdt-divider">${a.replace("1904", s.min)}</span>` : ""}${null == s.max || s.max4 ? "" : `<span class="hdt-divider">${r.replace("1904", s.max)}</span>`}`;
        const o = ["data-cart-quantity", "data-min", "data-max", "step"],
            h = [`${i ? i.quantity : 0}`, "min", "max", "increment"];
        for (const [t, e] of o.entries()) {
            const i = 0 === t ? h[t] : s[h[t]];
            null !== i ? this.input.setAttribute(e, i) : this.input.removeAttribute(e);
        }
        y(Zn, this, Qn).call(this);
    }),
    customElements.define("hdt-quantity-wrapp", aa);
class ra extends HTMLElement {
    #t;
    constructor() {
        super(), f(ia, this), f(ta, this), f(Kn, this, this.getAttribute("detect"));
    }
    connectedCallback() {
        this.#t = new AbortController();
        const t = u("[required]", this);
        0 != t.length &&
            (f(Gn, this, document.forms[this.attrForm]),
            w(Gn, this) &&
                (t.forEach((t) => {
                    t.removeAttribute("required"), this.classList.add("is-required");
                }),
                this.updateBreak(),
                "change" === this.getAttribute("event")
                    ? (setTimeout(() => (this.checked = d("input:checked", this)), 100),
                      this.addEventListener("change", y(ta, this, ea).bind(this), { signal: this.#t.signal }))
                    : this.addEventListener("input", A(y(ta, this, ea).bind(this), 150, this.#t.signal)),
                w(Gn, this).addEventListener("submit", y(ia, this, sa).bind(this), { signal: this.#t.signal })));
    }
    get attrForm() {
        return (this._attrForm = this._attrForm || d("[form]", this).getAttribute("form"));
    }
    updateBreak() {
        w(Gn, this).checkBreak =
            u(`hdt-block-required [form="${this.attrForm}"]`).length !=
            u(`hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`).length;
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    createStyle() {
        const t = [];
        let e,
            i = 0;
        for (e = 0; e < 10; e++) t.push(`translate3d(${arguments[i++]},0,0)`), i === arguments.length && (i = 0);
        return t;
    }
    set checked(t) {
        this.setChecked = t;
    }
    get checked() {
        return this.setChecked;
    }
}
(Gn = new WeakMap()),
    (Kn = new WeakMap()),
    (ta = new WeakSet()),
    (ea = function () {
        if (((this.checked = !1), "checked" === w(Kn, this))) d("input:checked", this) && (this.checked = !0);
        else {
            const t = d('input[type="text"]', this) || d("textarea", this);
            t && t.value.length > 0 && (this.checked = !0);
        }
        this.classList.remove("is-uncheck"), this.classList.toggle("is-required", !this.checked), this.updateBreak();
    }),
    (ia = new WeakSet()),
    (sa = function (t) {
        this.checked ||
            (t.preventDefault(),
            t.stopPropagation(),
            this.classList.remove("is-required"),
            this.classList.add("is-uncheck"),
            d(`hdt-block-required.is-uncheck [form="${this.attrForm}"]`).focus(),
            mt(
                this,
                { transform: this.createStyle(0, "-10px", "10px") },
                { offset: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1], duration: 1, ease: "ease" }
            ));
    }),
    customElements.define("hdt-block-required", ra);
class oa extends HTMLElement {
    #t;
    constructor() {
        super();
    }
    connectedCallback() {
        this.#t = new AbortController();
        const t = c(this.getAttribute("get-id"));
        t
            ? t.addEventListener("change", (e) => this.firstElementChild.toggleAttribute("disabled", !t.checked), {
                  signal: this.#t.signal,
              })
            : this.firstElementChild.removeAttribute("disabled"),
            this.addEventListener(
                "click",
                (e) => {
                    t.checked || this.closest("form")?.dispatchEvent(new Event("submit", { bubbles: !0 }));
                },
                { signal: this.#t.signal }
            );
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
customElements.define("hdt-need-checked-to-use", oa);
var ha,
    la,
    da,
    ca,
    ua,
    pa,
    ma,
    ba,
    ga = new WeakMap();
class va extends HTMLElement {
    #t;
    constructor() {
        super(), f(ha, this, !1), f(la, this), f(ga, this, d("form", this));
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            w(ga, this).addEventListener("change", y(la, this, da), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
(ha = new WeakMap()),
    (la = new WeakSet()),
    (da = async function (t) {
        if (w(ha, this) || !t.target.hasAttribute("will-change-cart")) return;
        f(ha, this, !0, !0);
        const e = t.detail && t.detail.target ? t.detail.target : t.target,
            i = e.closest(".hdt-cart-item");
        document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 })),
            i?.classList.add("hdt-pe-none");
        let s = [];
        document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: !0, detail: { sections: s } }));
        const n = await (
            await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ line: e.dataset.index, quantity: e.value || 0, sections: s.join(",") }),
            })
        ).json();
        f(ha, this, !1, !0),
            document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 })),
            i?.classList.remove("hdt-pe-none"),
            document.dispatchEvent(
                new CustomEvent("cart:change", { bubbles: !0, detail: { baseEvent: "line-item:change", cart: n } })
            );
    });
(pa = new WeakMap()),
    (ca = new WeakSet()),
    (ua = async function (t) {
        t.preventDefault(),
            w(pa, this).dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { target: this } }));
    });
class fa extends HTMLElement {
    #t;
    constructor() {
        super(), f(ma, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            this.addEventListener("change", y(ma, this, ba).bind(this), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
(ma = new WeakSet()),
    (ba = function (t) {
        const e = t.target.value;
        fetch(`${Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ note: e }),
            keepalive: !0,
        }),
            u("[data-label-note]").forEach((t) => {
                2 === t.childElementCount &&
                    (t.firstElementChild.toggleAttribute("hidden", e.length > 0),
                    t.lastElementChild.toggleAttribute("hidden", 0 === e.length));
            });
    });
var wa,
    ya,
    Ea,
    Ca,
    ka,
    xa,
    Aa,
    Sa,
    La,
    _a,
    Ma,
    Ta,
    Wa,
    Pa,
    Ia,
    $a,
    Oa,
    Ha,
    Na,
    Ra,
    qa,
    Da,
    Fa,
    Ba,
    Va,
    za,
    Ya,
    ja,
    Xa,
    Ua,
    Ja,
    Za,
    Qa,
    Ga,
    Ka = () =>
        new Promise(async (t) => {
            t(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
        }),
    tr = Ka();
document.addEventListener("cart:change", (t) => {
    tr = t.detail.cart;
}),
    document.addEventListener("cart:refresh", () => {
        tr = Ka();
    }),
    window.addEventListener("pageshow", (t) => {
        t.persisted && (tr = Ka());
    });
class er extends HTMLElement {
    #t;
    constructor() {
        super(), f(wa, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            document.addEventListener("cart:change", (t) => (this.itemCount = t.detail.cart.item_count), {
                signal: this.#t.signal,
            }),
            document.addEventListener("cart:refresh", y(wa, this, ya).bind(this), { signal: this.#t.signal }),
            window.addEventListener("pageshow", y(wa, this, ya).bind(this), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    set itemCount(t) {
        this.innerText = t;
    }
}
(wa = new WeakSet()),
    (ya = async function () {
        this.itemCount = (await tr).item_count;
    });
(Wa = new WeakMap()),
    (Ea = new WeakSet()),
    (Ca = async function (t, e = null) {
        const i = new DOMParser().parseFromString(t, "text/html"),
            s = d(".hdt-free-shipping-bar", i);
        let n = 0;
        s &&
            ((n = d(".hdt-progress-bar", s).getAttribute("aria-valuenow")),
            (d(".hdt-progress-bar", s).valueNow = d(".hdt-progress-bar", this).getAttribute("aria-valuenow")),
            d(".hdt-progress-bar", s).style.setProperty(
                "--progress-rate",
                d(".hdt-progress-bar", this).style.getPropertyValue("--progress-rate")
            ));
        const a = document
            .createRange()
            .createContextualFragment(
                i.getElementById(`shopify-section-${w(Wa, this)}`).querySelector("hdt-cart-drawer").innerHTML
            );
        if (0 === (e || (await tr).item_count)) {
            const t = gt([
                [this.selectorPartName("body"), { opacity: [1, 0] }, { duration: 0.15, easing: "ease-in" }],
                [
                    this.selectorPartName("footer"),
                    { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] },
                    { duration: 0.15, at: "<", easing: "ease-in" },
                ],
            ]);
            await t.finished,
                this.replaceChildren(...a.children),
                mt(
                    this.selectorPartName("body"),
                    { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] },
                    { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] }
                );
        } else this.replaceChildren(...a.children);
        s && (d(".hdt-progress-bar", this).valueNow = n),
            document.dispatchEvent(new CustomEvent("currency:update")),
            document.dispatchEvent(new CustomEvent("cart:drawer:render"));
    }),
    (ka = new WeakSet()),
    (xa = function (t) {
        t.detail.sections.push(w(Wa, this));
    }),
    (Aa = new WeakSet()),
    (Sa = function (t) {
        if (
            (y(Ea, this, Ca).call(this, t.detail.cart.sections[w(Wa, this)], t.detail.cart.item_count),
            t.detail.disabledDrawerChange ||
                document.dispatchEvent(
                    new CustomEvent("cart:drawer:change", { detail: { sections: t.detail.cart.sections } })
                ),
            "variant:add" === t.detail.baseEvent)
        ) {
            const e = t.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
            e.indexOf("go_") > -1
                ? (window.location.href = `${Shopify.routes.root}${"go_cart_page" == e ? "cart" : "checkout"}`)
                : "open_cart_drawer" == e && this.openDialog();
        }
    }),
    (La = new WeakSet()),
    (_a = function (t) {
        t.persisted && y(Ma, this, Ta).call(this);
    }),
    (Ma = new WeakSet()),
    (Ta = async function () {
        y(Ea, this, Ca).call(this, await (await fetch(`${Shopify.routes.root}?section_id=${w(Wa, this)}`)).text());
    });
($a = new WeakMap()),
    (Oa = new WeakSet()),
    (Ha = async function (t, e = null) {
        const i = new DOMParser().parseFromString(t, "text/html"),
            s = d(".hdt-free-shipping-bar", i),
            n = this.closest(".shopify-section");
        let a = 0;
        s &&
            ((a = d(".hdt-progress-bar", s).getAttribute("aria-valuenow")),
            (d(".hdt-progress-bar", s).valueNow = d(".hdt-progress-bar", n).getAttribute("aria-valuenow")),
            d(".hdt-progress-bar", s).style.setProperty(
                "--progress-rate",
                d(".hdt-progress-bar", n).style.getPropertyValue("--progress-rate")
            ));
        const r = d(".shopify-section [main-content]", i).innerHTML;
        if (0 === (e || (await tr).item_count)) {
            const t = mt(
                n,
                { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] },
                { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] }
            );
            await t.finished,
                (d("[main-content]", n).innerHTML = r),
                mt(
                    n,
                    { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] },
                    { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] }
                );
        } else d("[main-content]", n).innerHTML = r;
        s && (d(".hdt-progress-bar", n).valueNow = a),
            document.dispatchEvent(new CustomEvent("currency:update")),
            document.dispatchEvent(new CustomEvent("cart:page:render"));
    }),
    (Na = new WeakSet()),
    (Ra = function (t) {
        if ("variant:add" === t.detail.baseEvent) return (window.location.href = `${Shopify.routes.root}cart`);
        y(Oa, this, Ha).call(this, t.detail.cart.sections[w($a, this)], t.detail.cart.item_count);
    }),
    (Pa = new WeakSet()),
    (Ia = function (t) {
        t.detail.sections.push(w($a, this));
    }),
    customElements.define("wrapp-hdt-cart-form", va),
    customElements.define(
        "wrapp-hdt-cart-page-form",
        class extends va {
            #t;
            constructor() {
                super(), f($a, this, w(ga, this).getAttribute("section-id")), f(Oa, this), f(Pa, this), f(Na, this);
            }
            connectedCallback() {
                super.connectedCallback(),
                    (this.#t = new AbortController()),
                    document.addEventListener("cart:change", y(Na, this, Ra).bind(this), { signal: this.#t.signal }),
                    document.addEventListener("cart:push:section.id", y(Pa, this, Ia).bind(this), {
                        signal: this.#t.signal,
                    });
            }
            disconnectedCallback() {
                super.disconnectedCallback(), this.#t.abort();
            }
        }
    ),
    customElements.define(
        "wrapp-remove-item-oncart",
        class extends Qe {
            #t;
            constructor() {
                super(), f(ca, this);
            }
            connectedCallback() {
                super.connectedCallback(),
                    f(
                        pa,
                        this,
                        document.forms[(this.getAttribute("form") || "").replace("id:", "")] || this.closest("form")
                    ),
                    (this.#t = new AbortController()),
                    (this.abortController2 = null),
                    this.addEventListener("click", y(ca, this, ua).bind(this), { signal: this.#t.signal });
            }
            disconnectedCallback() {
                super.disconnectedCallback(), this.#t.abort();
            }
        }
    ),
    customElements.define("hdt-cart-note", fa),
    customElements.define("hdt-cart-count", er),
    customElements.define(
        "hdt-cart-dot",
        class extends er {
            set itemCount(t) {
                this.classList.toggle("is-visible", t > 0);
            }
        }
    ),
    customElements.define(
        "hdt-cart-drawer",
        class extends ei {
            constructor() {
                super(),
                    f(Wa, this, this.getAttribute("section-id")),
                    f(Ea, this),
                    f(ka, this),
                    f(Aa, this),
                    f(La, this),
                    f(Ma, this);
            }
            connectedCallback() {
                super.connectedCallback(),
                    document.addEventListener("cart:push:section.id", y(ka, this, xa).bind(this), {
                        signal: this.abortController.signal,
                    }),
                    document.addEventListener("cart:change", y(Aa, this, Sa).bind(this), {
                        signal: this.abortController.signal,
                    }),
                    document.addEventListener("cart:refresh", y(Ma, this, Ta).bind(this), {
                        signal: this.abortController.signal,
                    }),
                    window.addEventListener("pageshow", y(La, this, _a).bind(this), {
                        signal: this.abortController.signal,
                    });
            }
        }
    );
class ir extends HTMLElement {
    constructor() {
        super(),
            f(Da, this),
            f(qa, this, !this.hasAttribute("reveal-in-view")),
            f(Ba, this, this.getAttribute("data-colors"));
    }
    static get observedAttributes() {
        return ["aria-valuenow", "aria-valuemax"];
    }
    connectedCallback() {
        this.hasAttribute("reveal-in-view") &&
            vt(
                this,
                () => {
                    f(qa, this, !0, !0), y(Da, this, Fa).call(this);
                },
                { margin: "-50px 0px" }
            );
    }
    get progress() {
        return Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"));
    }
    set valueMax(t) {
        this.setAttribute("aria-valuemax", t);
    }
    set valueNow(t) {
        this.setAttribute("aria-valuenow", t);
    }
    attributeChangedCallback() {
        w(qa, this) && y(Da, this, Fa).call(this);
    }
}
(Ba = new WeakMap()),
    (qa = new WeakMap()),
    (Da = new WeakSet()),
    (Fa = function () {
        const t = JSON.parse(w(Ba, this)),
            e = (this.progress + "").slice(0, 3);
        if (t && t[e]) for (let [i, s] of Object.entries(t)) this.parentElement.classList.toggle(s, i == e);
        this.style.setProperty("--progress-rate", `${this.progress}`);
    }),
    customElements.define("hdt-progress-bar", ir);
class sr extends HTMLElement {
    #t;
    constructor() {
        super(...arguments), f(Va, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            (this.countryEl = d('[name="address[country]"]', this)),
            (this.provinceEl = d('[name="address[province]"]', this)),
            this.countryEl.addEventListener("change", y(Va, this, za).bind(this), { signal: this.#t.signal }),
            "" !== this.getAttribute("country") &&
                (this.countryEl.selectedIndex = Math.max(
                    0,
                    Array.from(this.countryEl.options).findIndex((t) => t.textContent === this.getAttribute("country"))
                )),
            this.countryEl.dispatchEvent(new Event("change"));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
(Va = new WeakSet()),
    (za = function () {
        const t = this.countryEl.options[this.countryEl.selectedIndex],
            e = JSON.parse(t.getAttribute("data-provinces"));
        (this.provinceEl.parentElement.hidden = 0 === e.length),
            (this.provinceEl.disabled = 0 === e.length),
            0 !== e.length &&
                ((this.provinceEl.innerHTML = ""),
                e.forEach((t) => {
                    const e = t[1] === this.getAttribute("province") || t[0] === this.getAttribute("province");
                    this.provinceEl.options.add(new Option(t[1], t[0], e, e));
                }));
    }),
    customElements.define("hdt-country-province-selector", sr);
var nr = class extends HTMLElement {
    #t;
    constructor() {
        super(),
            f(Ya, this),
            f(Xa, this),
            f(Ja, this),
            f(Qa, this),
            (this.langRates = JSON.parse(d("template[data-lang-rates]", this).innerHTML));
    }
    currencyMulti(t) {
        return (
            -1 !== themeHDN.settings.currencyFormat.indexOf("with_comma_separator") &&
                (t = t.replace(/[,.]/g, function (t) {
                    return "," === t ? "." : ",";
                })),
            parseFloat(t.replace(/^[^0-9]+|[^0-9.]/g, "", ""), 10) *
                (parseFloat(Shopify.currency.rate) *
                    (-1 == themeHDN.settings.currencyFormat.indexOf("with_comma_separator") ? 100 : 1))
        );
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            (this.submitButton = d('[type="button"]', this)),
            (this.resultsElement = d('[aria-live="polite"]', this)),
            this.submitButton.addEventListener("click", y(Ya, this, ja).bind(this), { signal: this.#t.signal });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
};
(Ya = new WeakSet()),
    (ja = async function (t) {
        t.preventDefault();
        const e = d('[name="address[zip]"]', this).value,
            i = d('[name="address[country]"]', this).value,
            s = d('[name="address[province]"]', this),
            n = s.disabled ? "" : s.value;
        this.submitButton.setAttribute("aria-busy", "true"),
            document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 }));
        const a = await fetch(
            `${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${i}&shipping_address[province]=${n}`,
            { method: "POST" }
        );
        if ((document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 })), a.ok)) {
            const t = await y(Xa, this, Ua).call(this, e, i, n);
            y(Ja, this, Za).call(this, t);
        } else {
            const t = await a.json();
            y(Qa, this, Ga).call(this, t);
        }
        (this.resultsElement.hidden = !1), this.submitButton.removeAttribute("aria-busy");
    }),
    (Xa = new WeakSet()),
    (Ua = async function (t, e, i) {
        const s = await fetch(
                `${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${t}&shipping_address[country]=${e}&shipping_address[province]=${i}`
            ),
            n = await s.text();
        return "null" === n ? y(Xa, this, Ua).call(this, t, e, i) : JSON.parse(n).shipping_rates;
    }),
    (Ja = new WeakSet()),
    (Za = function (t) {
        let e = t.map(
            (t) =>
                `<li>${t.presentment_name}: ${"0.00" == t.price ? this.langRates.free : `<span class="hdt-money">${k(this.currencyMulti(t.price), themeHDN.settings.currencyFormat)}</span>`}</li>`
        );
        (this.resultsElement.innerHTML = `\n    <div class="hdt-mess__rates is--rates-success">\n      <p>${0 === t.length ? this.langRates.no_rates : 1 === t.length ? this.langRates.one_rate : this.langRates.multiple_rates}</p>\n      ${"" === e ? "" : `<ul role="list">${e.join("")}</ul>`}\n    </div>\n  `),
            document.dispatchEvent(new CustomEvent("currency:update"));
    }),
    (Qa = new WeakSet()),
    (Ga = function (t) {
        let e = Object.keys(t).map((e) => `<li><span class="hdt-key__rate">${e}:</span> ${t[e]}</li>`);
        this.resultsElement.innerHTML = `\n      <div class="hdt-mess__rates is--rates-error">\n        <p>${this.langRates.errors}</p>\n        <ul role="list">${e.join("")}</ul>\n      </div>\n    `;
    }),
    customElements.define("hdt-shipping-calculator", nr);
class ar extends HTMLElement {
    static get observedAttributes() {
        return ["playing"];
    }
    connectedCallback() {
        (this._abortController = new AbortController()),
            this.hasAttribute("autoplay") && vt(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
    disconnectedCallback() {
        this._abortController.abort();
    }
    get playing() {
        return this.hasAttribute("playing");
    }
    get player() {
        return (this._playerProxy =
            this._playerProxy ||
            new Proxy(this._createPlayer(), {
                get: (t, e) => async () => {
                    (t = await t), this._playerApi(t, e);
                },
            }));
    }
    play() {
        this.playing || this.player.play();
    }
    pause() {
        this.playing && this.player.pause();
    }
    attributeChangedCallback(t, e, i) {
        "playing" === t &&
            (null === e && "" === i
                ? (this.dispatchEvent(new CustomEvent("media:play", { bubbles: !0 })),
                  this.hasAttribute("group") &&
                      Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`))
                          .filter((t) => t !== this)
                          .forEach((t) => {
                              t.pause();
                          }))
                : null === i && this.dispatchEvent(new CustomEvent("media:pause", { bubbles: !0 })));
    }
}
var rr = new Promise((t) => {
    window.onYouTubeIframeAPIReady = () => t();
});
import { PhotoSwipeLightbox as or, Zoom as hr } from "vendor";
var lr,
    dr,
    cr,
    ur,
    pr,
    mr,
    br,
    gr,
    vr,
    fr,
    wr = new WeakMap();
class yr extends HTMLElement {
    #t;
    constructor() {
        super(), f(lr, this), f(vr, this), f(cr, this), f(pr, this), f(br, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            this.form?.addEventListener(ls, y(lr, this, dr).bind(this), { signal: this.#t.signal }),
            this.sliderMain &&
                this.sliderMain.addEventListener("select:slide", y(cr, this, ur).bind(this), {
                    signal: this.#t.signal,
                }),
            this.updateGroupFilter &&
                this.addEventListener("update:value", y(vr, this, fr).bind(this), { signal: this.#t.signal }),
            "no" != this.imageZoom &&
                (u('.hdt-product-media__main [data-media-type="image"]', this).forEach((t) => {
                    t.addEventListener("click", y(pr, this, mr).bind(this, t), { signal: this.#t.signal });
                }),
                this.addEventListener("lightbox:psw:open", (t) => this.openLightBox(t?.detail?.index))),
            ("zoom" != this.imageZoom && "zoom_lightbox" != this.imageZoom) ||
                !_("supports-hover") ||
                y(br, this, gr).call(this);
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get form() {
        return (this._form = this._form || document.forms[this.getAttribute("form")]);
    }
    get sliderMain() {
        return (this._sliderMain = this._sliderMain || d(".hdt-product-media__main hdt-slider", this));
    }
    get sliderThumb() {
        return (this._sliderThumb = this._sliderThumb || d("hdt-slider-thumb", this));
    }
    get variantPicker() {
        return (this._variantPicker =
            this._variantPicker || d(`hdt-variant-picker[form="${this.getAttribute("form")}"]`));
    }
    get updateGroupFilter() {
        return this.hasAttribute("can-has-media-group");
    }
    get imageZoom() {
        return this.getAttribute("image-zoom");
    }
    get sectionId() {
        return this.getAttribute("section-id");
    }
    get lightBox() {
        if (w(wr, this)) return w(wr, this);
        let t = parseInt(this.getAttribute("max-zoom")) || 2;
        return (
            f(
                wr,
                this,
                new or({
                    pswpModule: () => import("photoswipe"),
                    bgOpacity: 1,
                    secondaryZoomLevel: t,
                    maxZoomLevel: ++t,
                    closeTitle: themeHDN.extras.pswp.close,
                    zoomTitle: themeHDN.extras.pswp.zoom,
                    arrowPrevTitle: themeHDN.extras.pswp.prev,
                    arrowNextTitle: themeHDN.extras.pswp.next,
                    errorMsg: themeHDN.extras.pswp.errorMsg,
                })
            ),
            w(wr, this).addFilter("thumbEl", (t, e) => e.thumbEl),
            w(wr, this).on("close", () => {
                const t = u('.hdt-product-media__main [data-media-type="image"]:not([hidden])')[
                    w(wr, this).pswp.currIndex
                ];
                t &&
                    (this.sliderMain && this.sliderMain.isActive
                        ? this.sliderMain.goToTarget(t, !0)
                        : t.scrollIntoView({ block: "start", behavior: "instant" }));
            }),
            w(wr, this).init(),
            w(wr, this)
        );
    }
    openLightBox(t = 0) {
        const e = u('.hdt-product-media__main [data-media-type="image"]:not([hidden]) img[hdt-el]', this).map((t) => ({
            thumbEl: t,
            src: t.src,
            srcset: t.srcset,
            msrc: t.currentSrc || t.src,
            width: parseInt(t.getAttribute("width")),
            height: parseInt(t.getAttribute("height")),
            alt: t.alt,
            thumbCropped: !0,
        }));
        this.lightBox.loadAndOpen(t, e);
    }
}
(lr = new WeakSet()),
    (dr = function (t) {
        const e = t.detail.variant;
        if ((y(vr, this, fr).call(this, e), e.mdid && t.detail.jumpMedia)) {
            const t = d(`.hdt-product-media__main [data-media-id="${e.mdid}"]`, this);
            t &&
                (this.sliderMain.isActive
                    ? this.sliderMain.goToTarget(t)
                    : t.scrollIntoView({ block: "start", behavior: "smooth" }));
        }
    }),
    (vr = new WeakSet()),
    (fr = function (t) {
        const e = t.options || t.detail.options;
        if (!this.updateGroupFilter) return;
        let i = !1;
        e.forEach((t, e) => {
            u(`[data-group-name="option${e}"][data-group-value="${t}"][hidden]`).length &&
                this.sliderMain.isActive &&
                (d("[data-media-type].is-selected hdt-video-player[loaded]", this)?.pause(), (i = !0)),
                u(`[data-group-name="option${e}"]`, this).forEach((e) => {
                    e.getAttribute("data-group-value") == t
                        ? e.removeAttribute("hidden")
                        : e.setAttribute("hidden", "");
                });
        }),
            i && (this.sliderMain.reInit(), this.sliderThumb?.reInit());
    }),
    (cr = new WeakSet()),
    (ur = function (t) {
        const e = t.detail.sliderApi,
            i = e.slideNodes()[e.selectedScrollSnap()],
            s = e.slideNodes()[e.previousScrollSnap()],
            n = i.getAttribute("data-media-id") || null,
            a = (i.dataset.variantsId || "").split(";");
        switch (
            (n &&
                this.variantPicker &&
                this.hasAttribute("update-when-variant-change") &&
                a[0] &&
                a.indexOf(this.form.id.value) < 0 &&
                this.variantPicker.selectVariantByID(a[0], !1),
            s.getAttribute("data-media-type"))
        ) {
            case "video":
            case "external_video":
                d("hdt-video-player[loaded]", s)?.pause();
        }
        switch (i.getAttribute("data-media-type")) {
            case "video":
            case "external_video":
                this.hasAttribute("autoplay-media") && d("hdt-video-player", i).play();
                break;
            case "model":
                _("phone") || d("hdt-model-player", i).play();
        }
    }),
    (pr = new WeakSet()),
    (mr = function (t) {
        const e = u('.hdt-product-media__main [data-media-type="image"]:not([hidden])', this);
        this.dispatchEvent(new CustomEvent("lightbox:psw:open", { bubbles: !0, detail: { index: e.indexOf(t) } }));
    }),
    (br = new WeakSet()),
    (gr = function () {
        var e = "zoom_fade_media",
            i = "zoom_fade_info",
            s = JSON.parse(this.getAttribute("zoom-options")),
            n = c(`product-zoom-${this.sectionId}`),
            a = c(`product-info-${this.sectionId}`),
            r = s.type,
            o = s.magnify,
            h = "external" == r;
        Shopify.designMode && d(".drift-zoom-pane, .drift-bounding-box")?.remove(),
            t.classList.add(`zoom-type--${r}`),
            u('.hdt-product-media__main [data-media-type="image"] img', this).forEach((t) => {
                new hr(t, {
                    sourceAttribute: "src",
                    zoomFactor: o,
                    inlinePane: !h && "inner2" == r,
                    containInline: h,
                    paneContainer: h ? n : t.parentElement,
                    hoverBoundingBox: h,
                    handleTouch: !1,
                    onShow: () => {
                        this.classList.add(e), a.classList.add(i);
                    },
                    onHide: () => {
                        this.classList.remove(e), a.classList.remove(i);
                    },
                });
            });
    });
class Er extends HTMLElement {
    constructor() {
        super(),
            this.addEventListener("click", () =>
                this.dispatchEvent(new CustomEvent("lightbox:psw:open", { bubbles: !0 }))
            );
    }
}
var Cr,
    kr = new WeakMap();
class xr extends HTMLElement {
    #t;
    constructor() {
        super(), f(Ar, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            this.dataset.objImg &&
                (y(Ar, this, Cr).call(this),
                this.addEventListener("click", () => this.lightBox?.loadAndOpen(this.dataset.index || 0), {
                    signal: this.#t.signal,
                }));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get lightBox() {
        return w(kr, this);
    }
    get objImg() {
        return this.getAttribute("obj-img");
    }
}
(Ar = new WeakSet()),
    (Cr = function () {
        let t = null;
        const e = JSON.parse(this.dataset.objImg);
        (e.srcset = T(
            e.src,
            JSON.parse(
                this.dataset.widths ||
                    `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${e.width}]`
            )
        )),
            (t = [e]);
        f(
            kr,
            this,
            new or({
                bgOpacity: 1,
                showHideAnimationType: "fade",
                pswpModule: () => import("photoswipe"),
                dataSource: t,
            })
        ),
            this.lightBox.init(),
            (t = null);
    });
var Ar = new WeakMap();
class Sr extends HTMLElement {
    #t;
    constructor() {
        super();
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            0 != this.images.length &&
                (console.log(this.lightbox),
                this.images.forEach((t, e) =>
                    t.addEventListener("click", this.openLightBox.bind(this, e), { signal: this.#t.signal })
                ));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get images() {
        return u(this.getAttribute("selector") || "img", this);
    }
    get lightBox() {
        if (w(Ar, this)) return w(Ar, this);
        const { close: t, zoom: e, prev: i, next: s, errorMsg: n } = themeHDN.extras.pswp;
        let a = parseInt(this.getAttribute("max-zoom")) || 2,
            r = this.images.map((t) => {
                const { src: e, currentSrc: i, alt: s } = t,
                    n = T(
                        e,
                        JSON.parse(
                            t.dataset.widths ||
                                `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${t.getAttribute("width")}]`
                        )
                    );
                return {
                    thumbnailElement: t,
                    src: e,
                    srcset: n,
                    msrc: i || e,
                    width: parseInt(t.getAttribute("width")),
                    height: parseInt(t.getAttribute("height")),
                    alt: s,
                    thumbCropped: !0,
                };
            });
        return (
            f(
                Ar,
                this,
                new or({
                    pswpModule: () => import("photoswipe"),
                    dataSource: r,
                    bgOpacity: 1,
                    secondaryZoomLevel: a,
                    maxZoomLevel: ++a,
                    closeTitle: t,
                    zoomTitle: e,
                    arrowPrevTitle: i,
                    arrowNextTitle: s,
                    errorMsg: n,
                })
            ),
            w(Ar, this).init(),
            (r = null),
            w(Ar, this)
        );
    }
    openLightBox(t = 0) {
        this.lightBox.loadAndOpen(t);
    }
}
customElements.define(
    "hdt-video-player",
    class extends ar {
        #i = !1;
        connectedCallback() {
            super.connectedCallback(),
                this.hasAttribute("autoplay") ||
                    this.addEventListener("click", this.play, { once: !0, signal: this._abortController.signal }),
                "video" === this.getAttribute("type") &&
                    vt(
                        this,
                        () => {
                            d("video", this)?.setAttribute("preload", "metadata");
                        },
                        { margin: "800px" }
                    );
        }
        _createPlayer() {
            if (this.hasAttribute("host"))
                return (
                    this.setAttribute("loaded", ""),
                    new Promise(async (t) => {
                        const e = d("template", this);
                        e && e.replaceWith(e.content.firstElementChild.cloneNode(!0)),
                            "background" === this.getAttribute("type") &&
                                (this.sizeBackgroundVideo(),
                                window.addEventListener("resize", A(this.sizeBackgroundVideo.bind(this), 300)));
                        const i = this.hasAttribute("autoplay") || _("phone"),
                            s = document.createElement("script");
                        if (((s.type = "text/javascript"), "youtube" === this.getAttribute("host"))) {
                            (window.YT && window.YT.Player) ||
                                ((s.src = "https://www.youtube.com/iframe_api"),
                                document.head.appendChild(s),
                                await new Promise((t) => {
                                    s.onload = t;
                                })),
                                await rr;
                            const e = new YT.Player(d("iframe", this), {
                                events: {
                                    onReady: () => {
                                        i && e.mute(), t(e);
                                    },
                                    onStateChange: (t) => {
                                        t.data === YT.PlayerState.PLAYING
                                            ? this.setAttribute("playing", "")
                                            : (t.data !== YT.PlayerState.ENDED && t.data !== YT.PlayerState.PAUSED) ||
                                              this.removeAttribute("playing");
                                    },
                                },
                            });
                        }
                        if ("vimeo" === this.getAttribute("host")) {
                            (window.Vimeo && window.Vimeo.Player) ||
                                ((s.src = "https://player.vimeo.com/api/player.js"),
                                document.head.appendChild(s),
                                await new Promise((t) => {
                                    s.onload = t;
                                }));
                            const e = new Vimeo.Player(d("iframe", this));
                            i && e.setMuted(!0),
                                e.on("play", () => {
                                    this.setAttribute("playing", "");
                                }),
                                e.on("pause", () => this.removeAttribute("playing")),
                                e.on("ended", () => this.removeAttribute("playing")),
                                t(e);
                        }
                    })
                );
            {
                const t = d("video", this);
                return (
                    this.setAttribute("loaded", ""),
                    t.addEventListener("play", () => {
                        this.setAttribute("playing", ""),
                            this.removeAttribute("suspended"),
                            this.#i && (t.controls = !1);
                    }),
                    t.addEventListener("pause", () => {
                        !t.seeking && t.paused && this.removeAttribute("playing");
                    }),
                    t
                );
            }
        }
        _playerApi(t, e) {
            "youtube" === this.getAttribute("host")
                ? t[`${e}Video`]()
                : "play" !== e || this.hasAttribute("host")
                  ? t[e]()
                  : t.play().catch((e) => {
                        "NotAllowedError" === e.name &&
                            (this.setAttribute("suspended", ""),
                            this.hasAttribute("controls") || ((this.#i = !0), (t.controls = !0)));
                    });
        }
        sizeBackgroundVideo() {
            var t,
                e,
                i,
                s,
                n = this.clientWidth,
                a = this.clientHeight;
            n / a < 16 / 9
                ? ((t = a * (16 / 9)), (e = a), (i = -Math.round((t - n) / 2)), (s = -Math.round((e - a) / 2)))
                : ((e = (t = n) * (9 / 16)), (s = -Math.round((e - a) / 2)), (i = -Math.round((t - n) / 2))),
                (d("iframe", this).style.cssText =
                    `max-width: 1000%; margin-left: ${i}px; margin-top: ${s}px; width: ${t}px; height: ${e}px;`);
        }
    }
),
    customElements.define(
        "hdt-model-player",
        class extends ar {
            connectedCallback() {
                super.connectedCallback(), this.player;
            }
            _createPlayer() {
                return new Promise((t) => {
                    this.setAttribute("loaded", ""),
                        window.Shopify.loadFeatures([
                            { name: "shopify-xr", version: "1.0", onLoad: this._setupShopifyXr.bind(this) },
                            {
                                name: "model-viewer-ui",
                                version: "1.0",
                                onLoad: () => {
                                    const e = d("model-viewer", this);
                                    e.addEventListener("shopify_model_viewer_ui_toggle_play", () =>
                                        this.setAttribute("playing", "")
                                    ),
                                        e.addEventListener("shopify_model_viewer_ui_toggle_pause", () =>
                                            this.removeAttribute("playing")
                                        ),
                                        t(new window.Shopify.ModelViewerUI(e, { focusOnPlay: !0 }));
                                },
                            },
                        ]);
                });
            }
            _playerApi(t, e) {}
            async _setupShopifyXr() {
                if (window.ShopifyXR) {
                    const t = c("ModelJson-" + this.getAttribute("section-id"));
                    window.ShopifyXR.addModels(JSON.parse(t.textContent)),
                        window.ShopifyXR.setupXRElements(),
                        this.closest("hdt-slider")?.reInit();
                } else document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
            }
        }
    ),
    customElements.define("hdt-product-media", yr),
    customElements.define("wrapp-open-pswp-media", Er),
    customElements.define("wrapp-open-pswp-btn", xr),
    customElements.define("hdt-gallery-modal", Sr);
var Lr,
    _r,
    Mr = new WeakMap();
class Tr extends HTMLElement {
    #t;
    constructor() {
        super(), f(Mr, this, u(".hdt-compare-color-item", this.closest(".hdt-modal__compare-color"))), f(Lr, this);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            (this.indexOrder = 0),
            u("button", this).forEach((t, e) => {
                ++this.indexOrder,
                    t.addEventListener("click", y(Lr, this, _r).bind(this, t, e), { signal: this.#t.signal });
            });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
(Lr = new WeakSet()),
    (_r = function (t, e) {
        const i = t.classList.toggle("is-hide-color");
        t.firstElementChild.toggleAttribute("hidden", i),
            t.lastElementChild.toggleAttribute("hidden", !i),
            console.log(this.indexOrder, e, w(Mr, this)),
            i
                ? (--this.indexOrder, w(Mr, this)[e].setAttribute("hidden", ""))
                : (++this.indexOrder,
                  w(Mr, this)[e].removeAttribute("hidden"),
                  (w(Mr, this)[e].style.order = this.indexOrder));
    }),
    customElements.define("hdt-compare-color-toogle", Tr);
class Wr extends HTMLElement {
    constructor() {
        super(),
            "true" !== sessionStorage.getItem(announceSize)
                ? this.addEventListener("click", (t) => {
                      Shopify.designMode || sessionStorage.setItem(announceSize, "true");
                      let e = this.closest(".hdt-section-group");
                      e.style.setProperty("overflow", "hidden"),
                          mt(e, { height: [`${e.clientHeight}px`, "0px"] }).finished.then(() => {
                              e.classList.add("hdt-announcement-hidden"), (announceSize = null);
                          });
                  })
                : (announceSize = null);
    }
}
customElements.define("wrapp-close-announce", Wr);
class Pr extends HTMLElement {
    #t;
    check = !0;
    constructor() {
        super();
    }
    connectedCallback() {
        this.#t = new AbortController();
        const t = { priority: this.getAttribute("priority") || "low", signal: this.#t.signal },
            e =
                this.url ||
                this.getAttribute("url") ||
                `${Shopify.routes.root}?section_id=${this.getAttribute("section-id")}`;
        e && this.lazyFetch(e, t);
    }
    disconnectedCallback() {
        this.check && this.#t.abort();
    }
    async lazyFetch(t, e) {
        const i = await I(t, "", e),
            s = new DOMParser().parseFromString(await i.text(), "text/html");
        this.check = !1;
        const n = d(".shopify-localization-form", s);
        if (n) {
            const t = c("localization_form_language");
            d('[name="return_to"]', n).value = t && t.return_to ? t.return_to.value : location.pathname;
        }
        this._replace(s);
    }
    _replace(t) {
        this.replaceWith(...t.body.children), this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: !0 }));
    }
}
var Ir = new Map();
customElements.define("hdt-lazy-html", Pr),
    customElements.define(
        "hdt-lazy-submenu",
        class extends Pr {
            check = !0;
            url = `${Shopify.routes.root}search?type=product&q=submenu${this.getAttribute("key") || ""}&section_id=${this.dataset.section}`;
            constructor() {
                super();
            }
            async lazyFetch(t, e) {
                if (Ir.has(t)) this.addEventListener("loaded:lazy", (t) => this._replace(t.detail.tempDiv));
                else {
                    Ir.set(t, !0);
                    const i = await I(t, "", e),
                        s = new DOMParser().parseFromString(await i.text(), "text/html");
                    (this.check = !1),
                        this._replace(s),
                        u(`hdt-lazy-submenu[data-section="${this.dataset.section}"]:not([id="${this.id}"])`).forEach(
                            (t) => {
                                t.dispatchEvent(
                                    new CustomEvent("loaded:lazy", { bubbles: !1, detail: { tempDiv: s } })
                                );
                            }
                        );
                }
            }
            _replace(t) {
                (this.innerHTML = t.querySelector(`#${this.id}`).innerHTML),
                    this.dispatchEvent(new CustomEvent("products:update", { bubbles: !0 })),
                    this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: !0 }));
            }
        }
    ),
    (() => {
        const e = "hdt-reveal",
            i = e + "--offscreen",
            s = e + "--cancel",
            n = (t) => {
                const e = t.target;
                e.isAnimationend && (e.setAttribute("animationend", ""), e.removeEventListener("animationend", n));
            };
        function a(t, e) {
            t.forEach((t, a) => {
                const r = t.target;
                r.setAttribute("observed", ""),
                    t.isIntersecting
                        ? (r.classList.contains(i) &&
                              (r.classList.remove(i),
                              r.hasAttribute("timeline") && r.style.setProperty("--animation-order", a)),
                          e.unobserve(r))
                        : (r.classList.add(i), r.classList.remove(s)),
                    (r.isAnimationend = !0),
                    r.addEventListener("animationend", n);
            });
        }
        function r(t = document, i = !1) {
            const s = u(`[${e}]:not([observed])`, t);
            if (0 === s.length) return;
            if (i)
                return void s.forEach((t) => {
                    t.classList.add(e + "--design-mode");
                });
            const n = new IntersectionObserver(a, { rootMargin: "0px 0px -50px 0px" });
            s.forEach((t) => n.observe(t));
        }
        themeHDN.settings.revealInView &&
            matchMedia("motion") &&
            (t.classList.add("hdt-reveal-in-view"),
            window.addEventListener("DOMContentLoaded", () => r()),
            Shopify.designMode &&
                (document.addEventListener(o, (t) => r(t.target, !0)),
                document.addEventListener(l, () => r(document, !0))));
        const h = () => {
            const e = window.innerWidth - document.body.clientWidth;
            e >= 0 && t.style.setProperty("--scrollbar-w", `${e}px`);
            const i = d("#MainContent .hdt-section");
            if (!i) return;
            const s = d(".md\\:hdt-height--full, .hdt-height--full", i);
            s &&
                s.offsetTop < window.innerHeight &&
                i.style.setProperty("--fill-height-first", 100 - s.offsetTop / (window.innerHeight / 100) + "vh");
        };
        (h(), window.addEventListener("resize", x(h)), _("supports-hover")) &&
            u(".hdt-btn-effect-3d").forEach((t) => {
                t.addEventListener("mousemove", function (e) {
                    const i = t.getBoundingClientRect(),
                        s = e.clientX - i.left - i.width / 2,
                        n = e.clientY - i.top - i.height / 2;
                    (t.style.transform = "translate(" + 0.15 * s + "px, " + 0.3 * n + "px)"),
                        (t.style.transform += "rotate3d(" + -0.1 * s + ", " + -0.3 * n + ", 0, 12deg)"),
                        t.children[0] &&
                            ((t.children[0].style.transition = "all .2s linear"),
                            (t.children[0].style.transform = "translate(" + 0.07 * s + "px, " + 0.14 * n + "px)"));
                }),
                    t.addEventListener("mouseleave", function () {
                        (t.style.transform = "translate3d(0px, 0px, 0px)"),
                            (t.style.transform += "rotate3d(0, 0, 0, 0deg)"),
                            t.children[0] && (t.children[0].style.transform = "translate3d(0px, 0px, 0px)");
                    });
            });
        if (
            (N(),
            R(),
            q(),
            navigator.userAgent &&
                /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                (d('meta[name="viewport"]', document.head).content =
                    "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0"),
            "ontouchend" in document)
        ) {
            let t = 0;
            const e = () => {
                ++t, t > 1 && document.removeEventListener("touchend", e);
            };
            document.addEventListener("touchend", e);
        }
        d("hdt-cart-drawer") ||
            "cart" == themeHDN.settings.pageType ||
            document.addEventListener("variant:add", (t) => {
                const e = t.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
                e.indexOf("go_") > -1 &&
                    (window.location.href = `${Shopify.routes.root}${"go_cart_page" == e ? "cart" : "checkout"}`);
            }),
            d("hdt-cart-drawer") &&
                document.addEventListener("variant:add", (t) => {
                    d("#hdt-quick-view-modal")?.hasAttribute("open") &&
                        d("#CartDrawer")?.hasAttribute("open") &&
                        d("#hdt-quick-view-modal").closeDialog();
                });
    })();
export {
    d as $4,
    u as $$4,
    c as $id4,
    f as getterAdd,
    w as getterGet,
    y as getterRunFn,
    i as isRTL,
    L as getUID,
    x as throttle,
    A as debounce,
    k as formatMoney,
    Qe as btnTooltip,
    _ as _matchMedia,
    I as cachedFetch,
    ei as Drawer,
    tn as VariantChangeBase,
    q as localeUrl,
};
